// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:13:52.708Z
// Property: Indian Hills (ID: 6737460151192626)
// Collections: 25 amenities, 12 floorplans (live), 33 photos, 77 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192626",
  "property_external_id": "4707260",
  "property_zillow_url": "https://www.zillow.com/b/indian-hills-north-little-rock-ar-FL3V/",
  "property_apartments_url": "https://www.apartments.com/indian-hills-apartments-north-little-rock-ar/5vf9t9q",
  "property_google_business_url": "https://www.google.com/maps/place/Indian+Hills/data=!4m2!3m1!1s0x0:0x5d450cc5900dac1d?sa=X&ved=2ahUKEwi4rPD0xbySAxW91fACHUPGAjsQ_BJ6BAg7EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321276568",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "indian-hills",
  "property_name": "Indian Hills",
  "property_website_url": "https://www.indianhillsapthome.com/",
  "property_domain": "https://www.indianhillsapthome.com/",
  "property_address": "2011 Aztec Dr",
  "property_full_address": "2011 Aztec Dr, North Little Rock, AR 72116",
  "property_address_1": "2011 Aztec Dr",
  "property_address_2": null,
  "property_address_city": "North Little Rock",
  "property_address_state": "AR",
  "property_address_zip_full": "72116-4403",
  "property_address_zip": "72116",
  "property_address_country": "US",
  "property_address_county": "Pulaski County",
  "property_neighborhood_address": "Indian Hills",
  "property_address_latitude": "34.8208539",
  "property_address_longitude": "-92.2393501",
  "property_email": "indianhills@rreafresidential.com",
  "property_phone": "(501) 835-8500",
  "property_call_tracking_phone": "501-530-8792",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Indian Hills in North Little Rock, AR, your ideal living space awaits! Choose from spacious one, two, or three-bedroom apartments, complete with top-notch amenities like a pet park and 24-hour maintenance. Experience convenience and comfort—explore our offerings and schedule a tour to claim your new home today!",
  "property_long_description": "Welcome to Indian Hills, your ideal retreat in the heart of North Little Rock, AR! Our vibrant apartment community offers a variety of spacious floor plans, including one-bedroom, two-bedroom, and three-bedroom options to suit every lifestyle. Whether you’re a young professional, a growing family, or simply looking to downsize, Indian Hills has the perfect home for you.\n\nExperience a community designed with your comfort and convenience in mind. Our amenities include a pet park, perfect for your furry friends, and 24-hour on-call maintenance to ensure your peace of mind. Enjoy the ease of online services and on-site management, along with convenient package receiving right at your doorstep. For those seeking flexibility, we also offer short-term lease options to fit your needs.\n\nAt Indian Hills, we pride ourselves on being the price leader in North Little Rock, allowing you to enjoy quality living without breaking the bank. With 24/7 availability, our dedicated team is always ready to assist you, making your living experience seamless and enjoyable.\n\nDon't miss out on your chance to call Indian Hills home! Discover your new apartment today—browse our availability or schedule a tour to visit our welcoming community. Your dream home awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-85f5-714d-875b-1a8256204a06.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and tables, adjacent to apartment buildings.",
    "public_id": "019e60f5-85f5-714d-875b-1a8256204a06",
    "storage_key": "property/6737460151192626/019e60f5-85f5-714d-875b-1a8256204a06.webp",
    "width": 3072,
    "height": 2050
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "169",
  "property_year_built": "1978",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "88.75739644970415",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply; please inquire with the office.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://indianhillsapartmenthomes.loftliving.com/login",
  "property_apply_now_url": "https://8444222.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-de4d-775b-a912-0ed1fb4392dc.webp",
  "property_primary_logo_media": {
    "alt_text": "Indian Hills property logo with mountains.",
    "public_id": "019e1df7-de4d-775b-a912-0ed1fb4392dc",
    "storage_key": "property/6737460151192626/019e1df7-de4d-775b-a912-0ed1fb4392dc.webp",
    "width": 1095,
    "height": 476
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-de4d-775b-a912-0ed1fb4392dc.webp",
  "property_secondary_logo_media": {
    "alt_text": "Indian Hills property logo with mountains.",
    "public_id": "019e1df7-de4d-775b-a912-0ed1fb4392dc",
    "storage_key": "property/6737460151192626/019e1df7-de4d-775b-a912-0ed1fb4392dc.webp",
    "width": 1095,
    "height": 476
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e8e87-4a3b-73dd-944d-6e20ceab6551.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-4a3b-73dd-944d-6e20ceab6551",
    "storage_key": "property/6737460151192626/019e8e87-4a3b-73dd-944d-6e20ceab6551.webp",
    "width": 1095,
    "height": 476
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e8e87-3c2d-71ec-8cf8-7f805ab39236.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-3c2d-71ec-8cf8-7f805ab39236",
    "storage_key": "property/6737460151192626/019e8e87-3c2d-71ec-8cf8-7f805ab39236.webp",
    "width": 1095,
    "height": 476
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#043481",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "563 - 1160",
  "property_sqft_min": "563",
  "property_sqft_max": "1160",
  "property_price_range": "779 - 1249",
  "property_price_min": "779",
  "property_price_max": "1249",
  "property_available_units": 19,
  "property_facebook_url": "https://www.facebook.com/IndianHillsApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/indian_hills_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJo-QPE-q90ocRHawNkMUMRV0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/indian-hills-apartments-north-little-rock-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Indian Hills",
  "property_home_romance_title": "Love Where You Live: Your Perfect Apartment Awaits",
  "property_home_amenities_blurb": "<p>Affordable pet-friendly apartment home living has never been more glamorous than at Indian Hills <a href=\"/floor-plans/\">apartments</a>. Nestled in North Little Rock, Arkansas, our prime location places you near great restaurants, shopping, and entertainment venues. Proudly situated in the North Little Rock School District and close to premier colleges and universities, everything you need is at your fingertips. Easy access to local interstates makes your daily commute and incredible day trips a breeze.</p>",
  "property_home_floorplans_blurb": "<p>Indian Hills apartments in Arkansas are in the center of the North Little Rock area. This region offers everything from dining to universities, all within a short distance. View a small sample of what our prime location offers.</p>",
  "property_home_gallery_blurb": "Welcome to Indian Hills, where comfort meets convenience in North Little Rock, AR. Choose from spacious one, two, or three-bedroom floor plans, complete with luxurious amenities like a sparkling pool, fitness center, and pet play area. Picture yourself enjoying the vibrant clubhouse or relaxing on your private balcony!",
  "property_home_neighborhood_blurb": "Nestled in the heart of North Little Rock, Indian Hills offers versatile one, two, and three-bedroom floor plans designed for your lifestyle. Uncover the vibrant neighborhood awaiting just outside your door, where local favorites and hidden gems invite you to experience community living like never before. Check it out!",
  "property_home_reviews_blurb": "At Indian Hills in North Little Rock, AR, our residents rave about our “amazing, sweet, and caring staff,” who are dedicated to creating a clean and beautiful community. Enjoy a pet-friendly environment and a prime location near local services, all while experiencing exceptional customer service. Join a place where neighbors become friends!",
  "property_neighborhood_blurb": "<p>Indian Hills apartments in Arkansas are in the center of the North Little Rock area. This region offers everything from dining to universities, all within a short distance. View a small sample of what our prime location offers.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Pets can enjoy frolicking around the bark park making lots of new friends and keeping clean in the dog wash station. Our business center and laundry facility are here so you can accomplish everything your life requires. We provide a shimmering swimming pool, a state-of-the-art fitness center, a playground, and a picnic area for fun with friends and building great memories. Call us today, and experience the quality and dedicated service you deserve at Indian Hills apartments in <a href=\"/neighborhood/\">North Little Rock, AR</a>.</p>",
  "property_applynow_blurb": "Welcome to Indian Hills in North Little Rock, AR, where comfort meets convenience. Choose from stunning one, two, or three-bedroom floor plans tailored for your lifestyle. Enjoy a pet park, 24/7 maintenance, and online services. Secure your ideal home today—apply online and start your next chapter!",
  "property_contactus_blurb": "At Indian Hills in North Little Rock, AR, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle needs. Whether you seek cozy solitude or space for collaboration, we have the perfect home waiting for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Indian Hills in North Little Rock, AR, we cater to your unique lifestyle with thoughtfully designed one, two, and three-bedroom floor plans. Have questions about our vibrant community? Dive into our FAQs page for insightful answers that will help you feel right at home. Your ideal apartment awaits!",
  "property_floorplans_blurb": "<p>Experience our 6 spacious floor plans of one, two, or three-bedroom apartments for rent designed with your comfort in mind. Each home <a href=\"/amenities/\">features</a> washer and dryer connections, central air conditioning and heating, and all-electric kitchens equipped with a dishwasher for easy clean-up. Enjoy expanded living space in every home with a personal balcony or patio, and there is plenty of storage room using the spacious walk-in closets. Select Indian Hills apartments include a washer and dryer and a cozy gas fireplace where the whole family, including your pets, can relax and unwind.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Indian Hills in North Little Rock, AR, find your ideal space among our diverse floor plans—one, two, or three bedrooms. Enjoy peace of mind with 24/7 on-call maintenance and an inviting pet park. Navigate our interactive community map to uncover your perfect home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Indian Hills in North Little Rock, AR, your ideal home awaits! Choose from our spacious one, two, or three-bedroom floor plans designed for comfort and style. Great friends make great neighbors—refer a friend today and enjoy exceptional living together in our welcoming community!",
  "property_residentaccess_blurb": "Welcome to Indian Hills in North Little Rock, AR! Elevate your living experience with our versatile floor plans, featuring one, two, and three-bedroom options. For our valued residents, easily manage your home online—pay rent, schedule maintenance, and stay connected. Log in to your resident portal and simplify your life today!",
  "property_reviews_blurb": "At Indian Hills in North Little Rock, residents praise our \"amazing, sweet, and caring staff\" who ensure a welcoming atmosphere and prompt maintenance service. Enjoy a community where \"friendly neighbors\" and a \"great location\" elevate your apartment living experience. See what our residents have to say about living at our community!",
  "property_created_at": "1752257253074",
  "property_scheduletour_blurb": "At Indian Hills in North Little Rock, AR, a lifestyle awaits you with thoughtfully designed one, two, and three-bedroom floor plans. Experience the perfect blend of comfort and convenience. Schedule a tour today and hear firsthand from our residents about the vibrant community that calls Indian Hills home!",
  "property_thankyou_blurb": "Thank you for reaching out! At Indian Hills in North Little Rock, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Look forward to connecting soon as we help you find your perfect retreat in our welcoming community!",
  "property_virtualtours_blurb": "<p>At Indian Hills, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Indian Hills",
  "property_seo_title_home": "Indian Hills | Apartments in North Little Rock, AR",
  "property_seo_description_home": "Welcome to Indian Hills in North Little Rock, AR – where comfort meets style across our thoughtfully designed floor plans. Choose from one, two, or three-bedroom apartments nestled within a vibrant community that boasts a pet park, 24-hour on-call maintenance, and online services for your convenience. Experience seamless living with on-site management and flexible short-term leases. Ready to elevate your lifestyle? Your perfect home awaits at Indian Hills!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in North Little Rock, AR",
  "property_seo_description_floorplans": "Unlock the perfect living experience at Indian Hills in North Little Rock, AR, where comfort meets style. Our thoughtfully designed floor plans cater to every lifestyle, featuring inviting one, two, and three-bedroom options that ensure a seamless blend of functionality and elegance. Browse our available apartment homes today to find the floor plan that complements your unique vision of home.",
  "property_seo_title_amenities": "Amenities | North Little Rock, AR Apartments for Rent",
  "property_seo_description_amenities": "Experience the charm of Indian Hills in North Little Rock, AR, where pet-friendly living meets convenience. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, complemented by a range of exceptional amenities. Enjoy 24-hour on-call maintenance, online services, and a welcoming pet park. With flexible short-term leasing options and dedicated on-site management, your comfort is our priority. Dive into a community that prioritizes your lifestyle; every detail at Indian Hills is crafted for your modern living. Explore our amenities today and see what makes us a price leader in the area!",
  "property_seo_title_gallery": "Gallery | Apartments in North Little Rock, AR",
  "property_seo_description_gallery": "Experience the charm of Indian Hills in North Little Rock, AR, where comfort meets community. Our photo gallery showcases stylish one, two, and three-bedroom floor plans alongside exceptional amenities like a pet park, 24/7 maintenance, and convenient online services. Whether you're in for a short-term stay or looking to settle down, picture your life surrounded by inviting spaces and a supportive on-site management team. Embrace the lifestyle you deserve, with unbeatable value as our price leader. Ready to make Indian Hills your new home? ",
  "property_seo_title_virtualtours": "Virtual Tours | Indian Hills Apartments",
  "property_seo_description_virtualtours": "\"Step into your dream home at Indian Hills in North Little Rock, AR! Experience our thoughtfully designed one, two, and three-bedroom floor plans through an immersive virtual tour. See how our vibrant community can elevate your lifestyle. Don’t miss the opportunity to find your perfect apartment—take the virtual tour today!\"",
  "property_seo_title_interactivemap": "Interactive Map | Indian Hills Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Indian Hills in North Little Rock, AR! Choose from our thoughtfully designed one, two, or three-bedroom floor plans, and enjoy unbeatable amenities like a pet park, 24/7 maintenance, and online services. Ready to move in? Our interactive community map makes it easy to search available apartments and see pricing—all at your fingertips! Your ideal living space awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Little Rock, AR",
  "property_seo_description_neighborhood": "\"At Indian Hills in North Little Rock, AR, your perfect home is just the beginning. Step outside and immerse yourself in a vibrant community filled with local gems, parks, and culinary delights. From our cozy one, two, and three-bedroom floor plans to the exciting spots nearby, there's always something to explore. Uncover the neighborhood’s hidden treasures and find your new favorite hangout today!\"",
  "property_seo_title_contact": "Contact Us | Indian Hills",
  "property_seo_description_contact": "Unlock the charm of Indian Hills in North Little Rock, AR, where comfort meets convenience. Choose from our thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. Have questions? Our leasing team is ready to assist you – reach out today and experience the welcoming community that awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in North Little Rock, AR",
  "property_seo_description_faqs": "Unlock the secrets of Indian Hills in North Little Rock, AR! Our FAQs page is your gateway to understanding our vibrant community, from spacious one, two, and three-bedroom floor plans to pet-friendly amenities like our delightful pet park. With 24/7 support and on-site management, we’re here to enhance your living experience. Get quick answers about our online services, short-term leasing, and exclusive advantages of being a price leader. Dive into the details and make your move today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Little Rock, AR",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at Indian Hills in North Little Rock, AR. Our thoughtfully designed one, two, and three-bedroom apartments cater to every need, complemented by exceptional amenities like a pet park, 24/7 on-call maintenance, and convenient online services. With our residents’ voices echoing the community’s charm and comfort, dive into their reviews and see why Indian Hills stands out as the price leader in modern living. Your new home awaits—join the conversation!",
  "property_seo_title_applynow": "Apply Now | Apartments in North Little Rock, AR",
  "property_seo_description_applynow": "Experience the comfort and convenience of Indian Hills in North Little Rock, AR, where modern living meets exceptional service. Choose from thoughtfully designed one, two, or three-bedroom floor plans, and enjoy amenities like a pet park, 24/7 maintenance, and hassle-free online leasing. With flexible short-term lease options and unparalleled on-site management, your ideal home awaits. Ready to elevate your lifestyle? Secure your new apartment today—applying has never been easier!",
  "property_seo_title_residentaccess": "Resident Access | Indian Hills",
  "property_seo_description_residentaccess": "\"Welcome to your Indian Hills resident portal—your one-stop access point for effortless living in North Little Rock, AR! Pay rent, schedule maintenance, and manage your home with ease. Connect with your community today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Indian Hills",
  "property_seo_description_referafriend": "\"Share the charm of Indian Hills in North Little Rock with your friends! When you refer a friend to our vibrant apartment community, you're not just sharing a home—you're inviting them to experience a lifestyle of comfort and camaraderie. Great friends make great neighbors—refer someone today and unlock exclusive rewards!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Indian Hills",
  "property_seo_description_scheduletour": "Experience the charm of Indian Hills in North Little Rock, AR! Schedule a tour today and step into a vibrant community where comfort meets convenience. Your ideal home awaits!",
  "property_seo_title_privacy": "Privacy Policy | Indian Hills",
  "property_seo_description_privacy": "\"At Indian Hills in North Little Rock, your privacy matters. Our comprehensive privacy policy outlines how we safeguard your personal information while you enjoy community living. Want to know more? View our privacy policy for peace of mind.\"",
  "property_seo_title_accessibility": "Website Accessibility | Indian Hills",
  "property_seo_description_accessibility": "\"At Indian Hills in North Little Rock, AR, we champion digital inclusion, ensuring every resident feels at home in our vibrant community. Our accessibility statement reflects our commitment to creating a welcoming environment for all. Join us in fostering a space where everyone belongs!\"",
  "property_seo_title_sitemap": "Sitemap | Indian Hills",
  "property_seo_description_sitemap": "\"Navigate your path to the perfect home at Indian Hills in North Little Rock, AR. Our comprehensive sitemap makes it easy to explore our vibrant community, amenities, and floor plans. Each click brings you closer to your ideal living experience—start your journey today!\"",
  "property_seo_title_thankyou": "Thank You | Indian Hills",
  "property_seo_description_thankyou": "Thank you for reaching out to Indian Hills in North Little Rock, AR! We're thrilled to connect with you soon. Your journey to a vibrant community filled with comfort and charm is just beginning. Stay tuned for more information from our friendly team!",
  "property_seo_title_pets": "Pet Policy | Apartments in North Little Rock, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293660342",
  "amenities": [
    {
      "id": "ec_8ca73a051d45e534705faec8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Wi‑Fi",
      "amount": "false",
      "description": "Confirmed—“Wi‑Fi” is listed under COMMUNITY AMENITIES exactly as provided.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5018ac4280947fb6b4e45d72",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "Confirmed—“Laundry Facilities” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad35d7629762904e95c97561",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Maintenance On Site",
      "amount": "false",
      "description": "Confirmed—“Maintenance On Site” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bae7cc3189d1bc268b7727f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Property Manager On Site",
      "amount": "false",
      "description": "Confirmed—“Property Manager On Site” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a6c25cbe0b1ec59c44a9fea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "Confirmed—“Online Services” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4b9fa9c5dd8e07ffe090b7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "Confirmed—“Planned Social Activities” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9de5864ffa1a83d571fe9daf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "Confirmed—“Pet Play Area” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a43597d1cfd73a3530ed9fad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "Confirmed—“Pet Washing Station” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_887700e8000ae0d36a01d6f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast/Coffee Concierge",
      "amount": "false",
      "description": "Confirmed—“Breakfast/Coffee Concierge” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c700ede9a7a34cc03d19dd8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "Confirmed—“Fitness Center” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac21355e45ae388bc3294a67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "Confirmed—“Pool” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_463fc23b311f8194c0d9e0a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "Confirmed—“Playground” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79912d29989eac26ccd1573b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "Confirmed—“Courtyard” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fdc45ed317f55f6e003dd3c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "Confirmed—“Grill” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cadfb94e2a0e13d32eef656",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "Confirmed—“Picnic Area” appears under COMMUNITY AMENITIES.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33a78b8f863c5923c68a7075",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "All‑electric Kitchen",
      "amount": "false",
      "description": "Confirmed—“All‑electric Kitchen” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66a0d346374cdcf68e560cca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio*",
      "amount": "false",
      "description": "Confirmed—“Balcony or Patio*” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06734ced981191444c0199b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "Confirmed—“Cable Ready” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b924b9f8862f670e68664588",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Central Air Conditioning and Heating",
      "amount": "false",
      "description": "Confirmed—“Central Air Conditioning and Heating” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_819992982787685e03f98d9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "Confirmed—“Dishwasher” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aec67b220a93c01ab241157d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Gas Fireplace*",
      "amount": "false",
      "description": "Confirmed—“Gas Fireplace*” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9fbf4b87748e11c00ccadc10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "Confirmed—“Microwave*” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e09b2de5332c1f39586ad6f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "Confirmed—“Walk‑in Closets” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d4c8d4b42187afd12470cfe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "Confirmed—“Washer and Dryer Connections” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_745c548bb2c7cacbe04702a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer in Home*",
      "amount": "false",
      "description": "Confirmed—“Washer and Dryer in Home*” appears under APARTMENT FEATURES.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3d81dd73-b900-4764-952e-ef60ed96f818",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-c819-768c-8b22-bf88572f539a.webp",
      "image_media": {
        "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and tables under a covered pergola.",
        "public_id": "019e60f5-c819-768c-8b22-bf88572f539a",
        "storage_key": "property/6737460151192626/019e60f5-c819-768c-8b22-bf88572f539a.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas for relaxation.",
      "link": "",
      "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and tables under a covered pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_784c609c-acfe-4285-852c-191766080be4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-c5de-7541-a77f-a4fbad1d3b75.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, and a weight bench.",
        "public_id": "019e60f5-c5de-7541-a77f-a4fbad1d3b75",
        "storage_key": "property/6737460151192626/019e60f5-c5de-7541-a77f-a4fbad1d3b75.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring a variety of cardio machines and weight training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, and a weight bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d7ac66e-4fa7-4b72-b460-8d67ca321dfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-d263-7788-924a-59a2411b49ec.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, gray tufted headboard, and a large window with blinds.",
        "public_id": "019e60f5-d263-7788-924a-59a2411b49ec",
        "storage_key": "property/6737460151192626/019e60f5-d263-7788-924a-59a2411b49ec.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable queen-size bed with plush bedding, a velvet headboard, and decorative pillows. Ample natural light streams in through the large window.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, gray tufted headboard, and a large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd12fbea-af57-45b1-92e3-4f07508d42b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-d103-76f5-b819-9d486ea4459d.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and a chandelier.",
        "public_id": "019e60f5-d103-76f5-b819-9d486ea4459d",
        "storage_key": "property/6737460151192626/019e60f5-d103-76f5-b819-9d486ea4459d.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table with plush chairs, a modern chandelier, and decorative wall art, perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and a chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dba5ac4f-fc7a-4a78-8095-4fcd0db624dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-d8be-765d-ba8b-54c75747e709.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, black appliances, and a view of the dining area.",
        "public_id": "019e60f5-d8be-765d-ba8b-54c75747e709",
        "storage_key": "property/6737460151192626/019e60f5-d8be-765d-ba8b-54c75747e709.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed kitchen featuring dark wood cabinetry, sleek black appliances, and a breakfast bar. Enjoy the convenience of a microwave and ample counter space, perfect for meal preparation. The adjacent dining area is ideal for intimate meals or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, black appliances, and a view of the dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_166c2fdd-1262-4d41-8b72-6e630fe3b92d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-daa7-754f-b52c-28c09a0b6695.webp",
      "image_media": {
        "alt_text": "Waiting area with coffee bar and reception desk",
        "public_id": "019e60f5-daa7-754f-b52c-28c09a0b6695",
        "storage_key": "property/6737460151192626/019e60f5-daa7-754f-b52c-28c09a0b6695.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and recharge in our comfortable waiting area, featuring a complimentary coffee bar and a welcoming reception desk for your convenience.",
      "link": "",
      "alt_text": "Waiting area with coffee bar and reception desk",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4196ee0c-f3f7-41cf-a257-7c3228db1cd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-dab6-7008-b33a-ecf291d254ad.webp",
      "image_media": {
        "alt_text": "Office reception area with desk, chairs, and a television.",
        "public_id": "019e60f5-dab6-7008-b33a-ecf291d254ad",
        "storage_key": "property/6737460151192626/019e60f5-dab6-7008-b33a-ecf291d254ad.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Welcome to our leasing office, equipped to assist you with all your needs. Browse floor plans or discuss your new home.",
      "link": "",
      "alt_text": "Office reception area with desk, chairs, and a television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_576fa9db-1ec5-4613-a17c-937dfcfd5052",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-d86e-707d-8ca9-a48a4f5456c4.webp",
      "image_media": {
        "alt_text": "Stylish living room with two teal armchairs, coffee table, and coffee station.",
        "public_id": "019e60f5-d86e-707d-8ca9-a48a4f5456c4",
        "storage_key": "property/6737460151192626/019e60f5-d86e-707d-8ca9-a48a4f5456c4.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Relax and unwind in the stylish living area, complete with comfortable seating and a convenient coffee station.",
      "link": "",
      "alt_text": "Stylish living room with two teal armchairs, coffee table, and coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_936926cf-8cc6-4052-8218-58eb04197564",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-d4a3-738f-b643-f2f1063ab24c.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sofa, blue accent chair, coffee table, and abstract art.",
        "public_id": "019e60f5-d4a3-738f-b643-f2f1063ab24c",
        "storage_key": "property/6737460151192626/019e60f5-d4a3-738f-b643-f2f1063ab24c.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Stylish and modern living room featuring a comfortable gray sofa, plush blue accent chair, elegant coffee table, and captivating abstract wall art.",
      "link": "",
      "alt_text": "Modern living room with gray sofa, blue accent chair, coffee table, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9e1b9277-a047-4b53-8247-3bb5b9d08ec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-d01a-73dd-8847-ffde35138538.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019e60f5-d01a-73dd-8847-ffde35138538",
        "storage_key": "property/6737460151192626/019e60f5-d01a-73dd-8847-ffde35138538.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for children of all ages.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f5abaaf-c0f4-4d4e-a7bd-765db9cd21ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-d136-752b-b1fb-dcb53bd463bd.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo with washer/dryer visible in reflection.",
        "public_id": "019e60f5-d136-752b-b1fb-dcb53bd463bd",
        "storage_key": "property/6737460151192626/019e60f5-d136-752b-b1fb-dcb53bd463bd.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a vanity with granite-look countertop, toilet, and a shower/tub combination. A stacked washer and dryer unit is visible in the reflection of the mirror.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo with washer/dryer visible in reflection.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_914431de-6fdb-41b8-b4ed-1595a3d7b850",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-cf75-7651-b8cb-49650bb34019.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with blue Adirondack chairs and tables under a wooden pergola.",
        "public_id": "019e60f5-cf75-7651-b8cb-49650bb34019",
        "storage_key": "property/6737460151192626/019e60f5-cf75-7651-b8cb-49650bb34019.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community grilling station, complete with comfortable seating and a spacious pergola.",
      "link": "",
      "alt_text": "Outdoor grilling station with blue Adirondack chairs and tables under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a41f62e-5dfc-48bf-8854-af1f4004cbaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-c8c6-73d9-871a-7ec8dcf53606.webp",
      "image_media": {
        "alt_text": "Dog park with tunnel and agility equipment",
        "public_id": "019e60f5-c8c6-73d9-871a-7ec8dcf53606",
        "storage_key": "property/6737460151192626/019e60f5-c8c6-73d9-871a-7ec8dcf53606.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, featuring a tunnel and agility equipment for your furry friends.",
      "link": "",
      "alt_text": "Dog park with tunnel and agility equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9be0952d-4416-42b9-8eb5-42932184613b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-c609-76cf-83f9-32f8c481cf46.webp",
      "image_media": {
        "alt_text": "Outdoor dog washing station with stainless steel tub and ramp.",
        "public_id": "019e60f5-c609-76cf-83f9-32f8c481cf46",
        "storage_key": "property/6737460151192626/019e60f5-c609-76cf-83f9-32f8c481cf46.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Convenient outdoor dog washing station available for residents. Features a durable stainless steel tub and an easy-access ramp for pets.",
      "link": "",
      "alt_text": "Outdoor dog washing station with stainless steel tub and ramp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_517f7d65-ce55-45dc-90ff-ba4368cd3db8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-c929-7059-a8b8-eae9e33d3eea.webp",
      "image_media": {
        "alt_text": "Community swimming pool with blue lounge chairs and buildings in the background.",
        "public_id": "019e60f5-c929-7059-a8b8-eae9e33d3eea",
        "storage_key": "property/6737460151192626/019e60f5-c929-7059-a8b8-eae9e33d3eea.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and outdoor seating, perfect for enjoying sunny days.",
      "link": "",
      "alt_text": "Community swimming pool with blue lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6e09fc41-6381-42f9-b783-294c5678ac82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-af23-732e-adc7-c6c2ce899928.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lots.",
        "public_id": "019e60f5-af23-732e-adc7-c6c2ce899928",
        "storage_key": "property/6737460151192626/019e60f5-af23-732e-adc7-c6c2ce899928.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "An aerial perspective showcases a well-maintained apartment complex, featuring multiple buildings, a sparkling swimming pool, ample parking, and surrounding green spaces.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lots.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4504bbfc-89af-44cf-9d47-8adfbc59f8ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-495a-7269-842b-8df91e1f20c4.webp",
      "image_media": {
        "alt_text": "Exterior building and landscaping with stone walkway and steps.",
        "public_id": "019e60f5-495a-7269-842b-8df91e1f20c4",
        "storage_key": "property/6737460151192626/019e60f5-495a-7269-842b-8df91e1f20c4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community, featuring beautifully maintained exteriors and landscaping, with charming stone walkways and steps leading to your front door.",
      "link": "",
      "alt_text": "Exterior building and landscaping with stone walkway and steps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae708b3c-300e-40d6-8fcd-1bdbdc0f7cda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-4568-742e-b326-866dae3e3e5a.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a wooden pergola, stone pillars, and blue chairs around tables.",
        "public_id": "019e60f5-4568-742e-b326-866dae3e3e5a",
        "storage_key": "property/6737460151192626/019e60f5-4568-742e-b326-866dae3e3e5a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling in our community's shaded seating area, complete with tables and chairs.",
      "link": "",
      "alt_text": "Outdoor seating area with a wooden pergola, stone pillars, and blue chairs around tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e7cc0a6-3740-485f-9562-5fe10431d24e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-27fd-759d-8dec-beae6d2dfd2e.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and a blue bench, fenced area with apartment buildings in the background.",
        "public_id": "019e60f5-27fd-759d-8dec-beae6d2dfd2e",
        "storage_key": "property/6737460151192626/019e60f5-27fd-759d-8dec-beae6d2dfd2e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility obstacles and comfortable seating, for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment and a blue bench, fenced area with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bdcae6fa-5ef1-4478-915a-a9f4420cbe5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-20da-75d3-8058-0576941e9260.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures in a residential area.",
        "public_id": "019e60f5-20da-75d3-8058-0576941e9260",
        "storage_key": "property/6737460151192626/019e60f5-20da-75d3-8058-0576941e9260.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for families.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures in a residential area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c008d87-8671-4491-b6f5-84b67c3f1fb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-1b0b-77d8-9305-aafb4b2760f2.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green lawn.",
        "public_id": "019e60f5-1b0b-77d8-9305-aafb4b2760f2",
        "storage_key": "property/6737460151192626/019e60f5-1b0b-77d8-9305-aafb4b2760f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of the apartment buildings, showcasing their balconies and the surrounding well-maintained lawn.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d5f10db-8854-484c-8a27-32801c119cec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f5-1441-725c-9563-7adcfede2804.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and well-maintained lawns.",
        "public_id": "019e60f5-1441-725c-9563-7adcfede2804",
        "storage_key": "property/6737460151192626/019e60f5-1441-725c-9563-7adcfede2804.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings set amidst lush green lawns, offering balconies and a welcoming exterior.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and well-maintained lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8fdc6d46-96ec-4b71-a09e-026df468f1fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-fffe-7569-9e88-a24978711ccc.webp",
      "image_media": {
        "alt_text": "Outdoor dog washing station with stainless steel tub and ramp.",
        "public_id": "019e60f4-fffe-7569-9e88-a24978711ccc",
        "storage_key": "property/6737460151192626/019e60f4-fffe-7569-9e88-a24978711ccc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient outdoor dog washing station with a stainless steel tub and ramp, perfect for keeping your furry friends clean.",
      "link": "",
      "alt_text": "Outdoor dog washing station with stainless steel tub and ramp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4de7e331-6f28-4589-a385-9041d28dddf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-f920-7488-83e3-ae85d16b3e4a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs and tables, surrounded by apartment buildings.",
        "public_id": "019e60f4-f920-7488-83e3-ae85d16b3e4a",
        "storage_key": "property/6737460151192626/019e60f4-f920-7488-83e3-ae85d16b3e4a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas. Perfect for relaxing and socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs and tables, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c51bc375-f51d-4ea3-9963-40af16f81633",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-f503-7741-a01b-fbdc3e5197c0.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with blue doors and balconies.",
        "public_id": "019e60f4-f503-7741-a01b-fbdc3e5197c0",
        "storage_key": "property/6737460151192626/019e60f4-f503-7741-a01b-fbdc3e5197c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of apartment buildings with manicured lawns and landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with blue doors and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d9cdd3d-9a1c-4621-bb5f-c5bcdf2de9fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-f0b9-7099-a2cd-fbc705c3fddc.webp",
      "image_media": {
        "alt_text": "Blue lounge chairs and tables surround a sparkling swimming pool with apartment buildings in the background.",
        "public_id": "019e60f4-f0b9-7099-a2cd-fbc705c3fddc",
        "storage_key": "property/6737460151192626/019e60f4-f0b9-7099-a2cd-fbc705c3fddc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the pool at our beautiful community. Enjoy the sunshine and the resort-style amenities.",
      "link": "",
      "alt_text": "Blue lounge chairs and tables surround a sparkling swimming pool with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_04ad9040-13e5-4714-b1d9-2d0f076de8a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-f17e-77c8-89c7-a4a0637d836b.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and tables, next to apartment buildings.",
        "public_id": "019e60f4-f17e-77c8-89c7-a4a0637d836b",
        "storage_key": "property/6737460151192626/019e60f4-f17e-77c8-89c7-a4a0637d836b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge seating and shaded areas.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and tables, next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10f422ce-d0a0-4e19-a8b2-2d68e3e8841a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-ddbd-746b-9093-b12777325730.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e60f4-ddbd-746b-9093-b12777325730",
        "storage_key": "property/6737460151192626/019e60f4-ddbd-746b-9093-b12777325730.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the sparkling outdoor pool, surrounded by comfortable lounge chairs and the beautiful apartment community.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fdb0d084-c69b-492c-b2b0-c7034cd760f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-dcde-7480-b849-e664b0fbe08f.webp",
      "image_media": {
        "alt_text": "Outdoor stainless steel grill with stone base and metal fencing in front of apartment buildings.",
        "public_id": "019e60f4-dcde-7480-b849-e664b0fbe08f",
        "storage_key": "property/6737460151192626/019e60f4-dcde-7480-b849-e664b0fbe08f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our built-in stainless steel grill, perfect for community gatherings and resident events.",
      "link": "",
      "alt_text": "Outdoor stainless steel grill with stone base and metal fencing in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1327d49-1788-4a01-b0ea-c3e7c72e2780",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-d7af-76e0-a8d4-b3d5b2202e2a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs and tables under a wooden pergola.",
        "public_id": "019e60f4-d7af-76e0-a8d4-b3d5b2202e2a",
        "storage_key": "property/6737460151192626/019e60f4-d7af-76e0-a8d4-b3d5b2202e2a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs and tables under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3af670c5-2b2e-4d06-ae27-94edaa1cfac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-dd49-76a8-8b80-c376185beda1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating area next to apartment buildings.",
        "public_id": "019e60f4-dd49-76a8-8b80-c376185beda1",
        "storage_key": "property/6737460151192626/019e60f4-dd49-76a8-8b80-c376185beda1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing or entertaining guests. Soak up the sun on the comfortable lounge chairs or gather with friends under the shaded pergola.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating area next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c090939-1aff-4f0d-98d3-94c34fd40974",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-d6c4-72ab-8e97-108fbf7431e1.webp",
      "image_media": {
        "alt_text": "Fitness center with weight bench, medicine balls, pull-up bar, and treadmill reflected in mirror.",
        "public_id": "019e60f4-d6c4-72ab-8e97-108fbf7431e1",
        "storage_key": "property/6737460151192626/019e60f4-d6c4-72ab-8e97-108fbf7431e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring cardio machines, free weights, and space for your personal training.",
      "link": "",
      "alt_text": "Fitness center with weight bench, medicine balls, pull-up bar, and treadmill reflected in mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10505351-53d5-4152-aba8-eab0dd206116",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e60f4-c837-707b-b3bb-5b9e568154fa.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a well-lit fitness center with mirrors and TVs.",
        "public_id": "019e60f4-c837-707b-b3bb-5b9e568154fa",
        "storage_key": "property/6737460151192626/019e60f4-c837-707b-b3bb-5b9e568154fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, ellipticals, and more, all with large mirrors and entertainment screens.",
      "link": "",
      "alt_text": "Treadmills and elliptical machines in a well-lit fitness center with mirrors and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e68065fa-91ac-41ee-a8e5-423618d8cb49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "7 Brew Coffee",
      "poi_type": "Restaurants",
      "poi_address": "7001 N John, F John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Drive-thru coffee shop featuring an assortment of beverages (teas, smoothies and milkshakes included).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-7d48-7685-84d4-9e0ec465529a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-7d48-7685-84d4-9e0ec465529a",
        "storage_key": "property/6737460151192626/019e1df9-7d48-7685-84d4-9e0ec465529a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://7brew.com/location/arkansas-north-little-rock-000324",
      "poi_directions_map_url": "https://maps.google.com/?cid=5357815884645580016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-brew-coffee",
      "poi_latitude": "34.8194698",
      "poi_longitude": "-92.236356",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 479-358-9274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-ce41-75a9-a1a2-d10ca06f2422.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df9-ce41-75a9-a1a2-d10ca06f2422",
        "storage_key": "property/6737460151192626/019e1df9-ce41-75a9-a1a2-d10ca06f2422.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ6xkOVHi90ocR8Lw-ACnJWko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_aa477e66-8f5a-4f37-b307-be983d10dd60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Blue Sail Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1028 Front St, Conway, AR 72032, USA",
      "poi_short_description": "Coffeehouse that roasts its own beans and offers other drinks and pastries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-7c50-72d7-b8b0-1e834035ae98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-7c50-72d7-b8b0-1e834035ae98",
        "storage_key": "property/6737460151192626/019e1df9-7c50-72d7-b8b0-1e834035ae98.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.bluesailcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13098532391747226110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-sail-coffee",
      "poi_latitude": "35.092529",
      "poi_longitude": "-92.441513",
      "poi_miles_from_property": "31.3",
      "poi_walking_minutes": "11 hours 23 mins",
      "poi_biking_minutes": "3 hours 9 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 501-536-7899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-ce41-75a9-a1a2-d10ca06f2422.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df9-ce41-75a9-a1a2-d10ca06f2422",
        "storage_key": "property/6737460151192626/019e1df9-ce41-75a9-a1a2-d10ca06f2422.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJAdqhExiC0ocR_okKsc9Vx7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_fc7e2785-57db-4494-b769-e22b181f9af0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "5105 Warden Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-8286-754e-b3b3-532a3a7b2223.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-8286-754e-b3b3-532a3a7b2223",
        "storage_key": "property/6737460151192626/019e1df9-8286-754e-b3b3-532a3a7b2223.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chuys.com/locations/ak/north-little-rock/north-little-rock-ak/6058?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:north-little-rock-ar-6058_pl:locurl_rd:1057",
      "poi_directions_map_url": "https://maps.google.com/?cid=1396580293695292991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuys",
      "poi_latitude": "34.8011245",
      "poi_longitude": "-92.2159118",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-771-2440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcTYV_Xy-0ocRP8YEsmCmYRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_5daed382-07d8-477f-b8bc-3ea4936d18fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "5103 Warden Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-74ba-760a-b3eb-3cdac312f9a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-74ba-760a-b3eb-3cdac312f9a3",
        "storage_key": "property/6737460151192626/019e1df9-74ba-760a-b3eb-3cdac312f9a3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13454279065326792685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "34.8006295",
      "poi_longitude": "-92.2164784",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-270-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR9VOCH2-0ocR7S_HrYYzt7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_6f726638-c251-49d1-8ca0-8c21984cfe70",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "5001 Warden Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-849d-75a0-a15b-e6aaf28a425d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-849d-75a0-a15b-e6aaf28a425d",
        "storage_key": "property/6737460151192626/019e1df7-849d-75a0-a15b-e6aaf28a425d.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/711/golden-corral-warden-road?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=711",
      "poi_directions_map_url": "https://maps.google.com/?cid=666018445816855153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "34.7979916",
      "poi_longitude": "-92.2196923",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-771-4605",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc-61qYC-0ocRcXrFbD8sPgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_72387bbe-bf81-4b33-a0c6-8b92962a9790",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "3601 Warden Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-74ad-7039-89d1-2a98de6e4d96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-74ad-7039-89d1-2a98de6e4d96",
        "storage_key": "property/6737460151192626/019e1df9-74ad-7039-89d1-2a98de6e4d96.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/arkansas/north-little-rock?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15920787917745738475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "34.7867491",
      "poi_longitude": "-92.2293573",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-771-4230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21Ry9yW80ocR69KQXUIA8tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_9f280ade-a531-42b3-b8e8-5f6b146ebef4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4401 Warden Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-7d59-70f9-9968-264e0f0f00dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-7d59-70f9-9968-264e0f0f00dc",
        "storage_key": "property/6737460151192626/019e1df9-7d59-70f9-9968-264e0f0f00dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.outback.com/arkansas/north-little-rock/4401-warden-road?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDIyNDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5506119532514979072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "34.7962246",
      "poi_longitude": "-92.2204594",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-771-7799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_uJ44C-0ocRAC1lyoqqaUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_348deb62-52e5-49c0-808a-ea5811789ce7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "3911 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-81a6-77ee-a679-feff4d1a4a1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-81a6-77ee-a679-feff4d1a4a1c",
        "storage_key": "property/6737460151192626/019e1df9-81a6-77ee-a679-feff4d1a4a1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ar/north-little-rock/north-little-rock-mccain-mall/5597?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:north-little-rock-ar-5597_pl:locurl_rd:1517",
      "poi_directions_map_url": "https://maps.google.com/?cid=18257088354443444865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "34.7918046",
      "poi_longitude": "-92.2288302",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-753-4629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdMJPsq90ocRgcKFzyA1Xv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_cd45bd3c-54ab-4eaf-ba43-ec83ca91157b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Rivera Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2629 Lakewood Village Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Casual Italian eatery offering chicken entrees, veal, seafood, and pastas plus wine and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-7c17-77ef-9d8c-7deb1b188fbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-7c17-77ef-9d8c-7deb1b188fbc",
        "storage_key": "property/6737460151192626/019e1df9-7c17-77ef-9d8c-7deb1b188fbc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.riveralittlerock.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18444126938544650906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rivera-italian-restaurant",
      "poi_latitude": "34.7966785",
      "poi_longitude": "-92.2339295",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-955-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3M8NTe_0ocRmroqvLqz9v8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b5113fab-0293-471e-aad8-14d271bd7bc3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "2812 Lakewood Village Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-75d4-712e-92fe-7dfeae5a38f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-75d4-712e-92fe-7dfeae5a38f7",
        "storage_key": "property/6737460151192626/019e1df9-75d4-712e-92fe-7dfeae5a38f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ar/north-little-rock/2812-lakewood-village-drive?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=606204&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=12456298066679362108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "34.79447",
      "poi_longitude": "-92.232596",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-771-0168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-ce41-75a9-a1a2-d10ca06f2422.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df9-ce41-75a9-a1a2-d10ca06f2422",
        "storage_key": "property/6737460151192626/019e1df9-ce41-75a9-a1a2-d10ca06f2422.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJj7oiIy280ocRPPLOaBip3aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_020d3a5a-f158-4706-9761-cfd67f7787ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Larry's Pizza of NLR",
      "poi_type": "Restaurants",
      "poi_address": "5933 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "No-frills local chain restaurant offering lots of specialty pizzas, plus sandwiches & salads.",
      "poi_long_description": "No-frills local chain restaurant offering lots of specialty pizzas, plus sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-7464-73ec-8bc8-a4e67a81f207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-7464-73ec-8bc8-a4e67a81f207",
        "storage_key": "property/6737460151192626/019e1df9-7464-73ec-8bc8-a4e67a81f207.webp",
        "width": 1280,
        "height": 632
      },
      "poi_business_url": "http://larryspizzaofarkansas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17801530169184507833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "larrys-pizza-of-nlr",
      "poi_latitude": "34.8098588",
      "poi_longitude": "-92.2483805",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-812-5353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZ3GXbi90ocRuVekUF-9C_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_561677c5-e2bb-49d3-9a03-253eea85698b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Chicken City",
      "poi_type": "Restaurants",
      "poi_address": "5107 Warden Rd #6, North Little Rock, AR 72116, USA",
      "poi_short_description": "Fast-food, grocery-style place serving bulk frozen foods, like breaded chicken nuggets and fries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-8278-7748-a2ca-56f0a7db5b84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-8278-7748-a2ca-56f0a7db5b84",
        "storage_key": "property/6737460151192626/019e1df9-8278-7748-a2ca-56f0a7db5b84.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13212272580990937446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-city",
      "poi_latitude": "34.8021369",
      "poi_longitude": "-92.2149955",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-353-1264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSo16ny-0ocRZimZKelrW7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_20554bfc-d882-4f6c-9f83-a534fafa9d9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Flyway Brewing",
      "poi_type": "Restaurants",
      "poi_address": "314 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-85f6-7052-a8c0-a67b71b8610f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-85f6-7052-a8c0-a67b71b8610f",
        "storage_key": "property/6737460151192626/019e1df9-85f6-7052-a8c0-a67b71b8610f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flywaybrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9212740221938584033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flyway-brewing",
      "poi_latitude": "34.7567912",
      "poi_longitude": "-92.2688016",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-812-3192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yyyxIO80ocR4UmasGs62n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_f9d49eff-0b20-4638-b761-856bb88f90ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Capeo | Italian",
      "poi_type": "Restaurants",
      "poi_address": "425 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Refined Italian menu with a long wine list presented in an intimate space with an open kitchen.",
      "poi_long_description": "Refined Italian menu with a long wine list presented in an intimate space with an open kitchen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-864f-7652-894a-c6d7ea9abd7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-864f-7652-894a-c6d7ea9abd7f",
        "storage_key": "property/6737460151192626/019e1df9-864f-7652-894a-c6d7ea9abd7f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.capeo.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2349934928727282787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capeo--italian",
      "poi_latitude": "34.7579292",
      "poi_longitude": "-92.2678874",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-376-3463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7b9-7743-89b0-087502c49cc0",
        "storage_key": "property/6737460151192626/019e1df7-c7b9-7743-89b0-087502c49cc0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6xP_YO80ocRY5QSAF6lnCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_718d8979-ee16-4b43-98cb-2b434dd5fef9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Reno's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "312 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Neighborhood hangout offering sandwiches, gyros & pizzas, plus a full bar & live music on weekends.",
      "poi_long_description": "Neighborhood hangout offering sandwiches, gyros & pizzas, plus a full bar & live music on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-8a25-734f-974d-00e8717fe088.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-8a25-734f-974d-00e8717fe088",
        "storage_key": "property/6737460151192626/019e1df9-8a25-734f-974d-00e8717fe088.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://renoscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14858137782810764992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renos-cafe",
      "poi_latitude": "34.7566161",
      "poi_longitude": "-92.2675925",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-376-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7f6-746c-b0b5-db49f03db621.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7f6-746c-b0b5-db49f03db621",
        "storage_key": "property/6737460151192626/019e1df7-c7f6-746c-b0b5-db49f03db621.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT31EZYG80ocRwOY-eJe1Ms4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_68a60cc9-ec2d-4dc8-9341-dff721acbb20",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2509 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-8476-71c8-93a0-f2e3d42dd801.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-8476-71c8-93a0-f2e3d42dd801",
        "storage_key": "property/6737460151192626/019e1df7-8476-71c8-93a0-f2e3d42dd801.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ar/north-little-rock/mccain/025/00639?cid=loc_02500639_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1062804925109617215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "34.7978759",
      "poi_longitude": "-92.2357927",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-758-8660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7d5-74b5-874c-1398b1b3fa90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7d5-74b5-874c-1398b1b3fa90",
        "storage_key": "property/6737460151192626/019e1df7-c7d5-74b5-874c-1398b1b3fa90.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPVeu1TK80ocRP8KxynLXvw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fb953664-9561-4cc2-a94c-274574b56a8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "4823 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-8b17-7162-9291-fee7fe93c47c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-8b17-7162-9291-fee7fe93c47c",
        "storage_key": "property/6737460151192626/019e1df9-8b17-7162-9291-fee7fe93c47c.webp",
        "width": 1280,
        "height": 868
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4823+john+f+kennedy+blvd-north+little+rock-ar-72116/id=3416",
      "poi_directions_map_url": "https://maps.google.com/?cid=16809595157491161868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.79976360000001",
      "poi_longitude": "-92.25572710000002",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-771-1971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2Xt_ay90ocRDBtjFLytR-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_012b1a6f-7f46-4efe-befd-da59ba1bfd07",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Cornerstone Pharmacy Lakewood",
      "poi_type": "Shopping & Retail",
      "poi_address": "2609 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-88c1-768c-94d5-0a1d235367c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-88c1-768c-94d5-0a1d235367c7",
        "storage_key": "property/6737460151192626/019e1df9-88c1-768c-94d5-0a1d235367c7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cornerstonepharmacy.com/cornerstone-pharmacy-locations/cornerstone-pharmacy-lakewood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12869632871358594481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornerstone-pharmacy-lakewood",
      "poi_latitude": "34.7964958",
      "poi_longitude": "-92.2346119",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-353-1984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-ce42-7641-b0b8-ad1c442fe179.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df9-ce42-7641-b0b8-ad1c442fe179",
        "storage_key": "property/6737460151192626/019e1df9-ce42-7641-b0b8-ad1c442fe179.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSbh5TK80ocRsf0EB-kemrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d9734ba0-60d4-438c-bdbf-032ad51bacfb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "McCain Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3929 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Sheltered complex featuring major & boutique stores, services & a variety of dining options.",
      "poi_long_description": "Sheltered complex featuring major & boutique stores, services & a variety of dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-86f5-713c-adcf-03ec2f06bfc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-86f5-713c-adcf-03ec2f06bfc9",
        "storage_key": "property/6737460151192626/019e1df7-86f5-713c-adcf-03ec2f06bfc9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/mccain-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=5997340656104035792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mccain-mall",
      "poi_latitude": "34.7928004",
      "poi_longitude": "-92.2265383",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-758-6340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c841-7379-bf44-02dc6c163f86",
        "storage_key": "property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRbuB2iu80ocR0NUWLI3VOlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1a36220e-3560-4c92-a9fb-6541c506df43",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4000 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-8cf8-713d-8dff-2b4a5b4e9a02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-8cf8-713d-8dff-2b4a5b4e9a02",
        "storage_key": "property/6737460151192626/019e1df9-8cf8-713d-8dff-2b4a5b4e9a02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/little-rock-north/162",
      "poi_directions_map_url": "https://maps.google.com/?cid=5304223806694593745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "34.7880996",
      "poi_longitude": "-92.2290477",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-771-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c841-7379-bf44-02dc6c163f86",
        "storage_key": "property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBZfj0Si80ocR0ZQz_3JjnEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c97c17b6-69c7-4932-be28-578bd6de5ec0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "4220 McCain Blvd, North Little Rock, AR 72117, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-9596-73b7-8220-5b6289b13002.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-9596-73b7-8220-5b6289b13002",
        "storage_key": "property/6737460151192626/019e1df9-9596-73b7-8220-5b6289b13002.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ar/north-little-rock/4220-e-mccain-blvd/fl07",
      "poi_directions_map_url": "https://maps.google.com/?cid=3163722864516566669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "34.78773",
      "poi_longitude": "-92.22072",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7d5-74b5-874c-1398b1b3fa90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7d5-74b5-874c-1398b1b3fa90",
        "storage_key": "property/6737460151192626/019e1df7-c7d5-74b5-874c-1398b1b3fa90.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwJv-Q-_0ocRjY5K4y7N5ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_30bdc37c-e4d6-4887-99ce-8d9970d7a174",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "4613 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-8ef3-76dd-8746-9c343afe6baf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-8ef3-76dd-8746-9c343afe6baf",
        "storage_key": "property/6737460151192626/019e1df9-8ef3-76dd-8746-9c343afe6baf.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ar/north-little-rock/4156",
      "poi_directions_map_url": "https://maps.google.com/?cid=8463519931787597148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "34.7973336",
      "poi_longitude": "-92.2568081",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-313-3270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c841-7379-bf44-02dc6c163f86",
        "storage_key": "property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdSIyrR4UIBURXFWjS4l2dHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_02777ac9-e881-426e-accc-5a3776738094",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "2808 Lakewood Village Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-8e6d-7161-9134-941639e4b3e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-8e6d-7161-9134-941639e4b3e3",
        "storage_key": "property/6737460151192626/019e1df9-8e6d-7161-9134-941639e4b3e3.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ar/north-little-rock/2808-lakewood-village-dr?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5186531015405354609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "34.794697",
      "poi_longitude": "-92.2328978",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-859-9455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c841-7379-bf44-02dc6c163f86",
        "storage_key": "property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxYY1Iy280ocRcT7IpXpC-kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_9bc08bc7-10b4-46bc-8e2c-f5ebda4bcfb9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Indian Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "6800 Indian Hills Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nlrsd.org/o/indian-hills-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=3920808800682816028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-hills-elementary-school",
      "poi_latitude": "34.818418",
      "poi_longitude": "-92.240431",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 501-835-5622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH0do8sG90ocRHLLstNSCaTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_10fcf285-83ab-4338-81da-d1b5ada43de9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Lakewood Elementary School",
      "poi_type": "Education",
      "poi_address": "1800 Fairway Ave, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.nlrsd.org/o/lakewood-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=13879025839138286690&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakewood-elementary-school",
      "poi_latitude": "34.7945769",
      "poi_longitude": "-92.246443",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-771-8270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUSw9TEq80ocRYixOanc0nMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_26bfcec7-9f97-48f3-87c9-cd8799ca79c0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "North Little Rock Middle School 6th Grade Campus",
      "poi_type": "Education",
      "poi_address": "2300 Lakeview Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nlrsd.org/o/middle-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=4046122634365582852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-middle-school-6th-grade-campus",
      "poi_latitude": "34.7857764",
      "poi_longitude": "-92.2345965",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-771-8250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOU8KdwS90ocRBD4HQxm3Jjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_957c1c62-6492-4464-a13d-08d51303b148",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "North Little Rock Middle School",
      "poi_type": "Education",
      "poi_address": "2400 Lakeview Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.nlrsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=244976341614849333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-middle-school",
      "poi_latitude": "34.787885",
      "poi_longitude": "-92.231354",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-771-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSdGgvjq80ocRNe1TTK9UZgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b10ab387-3da1-43b4-afe6-1d572c308137",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "North Little Rock High School",
      "poi_type": "Education",
      "poi_address": "201 W 22nd St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-9599-779f-9390-ef7077857d9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-9599-779f-9390-ef7077857d9e",
        "storage_key": "property/6737460151192626/019e1df9-9599-779f-9390-ef7077857d9e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nlrsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8188116334975508691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-high-school",
      "poi_latitude": "34.776321",
      "poi_longitude": "-92.269072",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-771-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdaP0tvS80ocR0-DJlWwIonE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_96d09cc9-f819-48e8-839a-6efa2163e0e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Pike View Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "441 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-93eb-7292-9b95-1c9fc107f83b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-93eb-7292-9b95-1c9fc107f83b",
        "storage_key": "property/6737460151192626/019e1df9-93eb-7292-9b95-1c9fc107f83b.webp",
        "width": 1280,
        "height": 740
      },
      "poi_business_url": "http://nlrsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1828821698467831290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pike-view-early-childhood-center",
      "poi_latitude": "34.8016235",
      "poi_longitude": "-92.2607826",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-771-8170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW39lDAC90ocR-p2zLqVHYRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_8bc174ca-801a-476c-86db-6b09b94dfd11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Immaculate Conception School",
      "poi_type": "Education",
      "poi_address": "7000 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-93ab-7112-8d98-a94301063bfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-93ab-7112-8d98-a94301063bfa",
        "storage_key": "property/6737460151192626/019e1df9-93ab-7112-8d98-a94301063bfa.webp",
        "width": 1193,
        "height": 587
      },
      "poi_business_url": "http://www.icsnlr.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11531386918243653115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "immaculate-conception-school",
      "poi_latitude": "34.818092",
      "poi_longitude": "-92.235636",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 501-835-0771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrcUzb8K90ocR-9V_ZU63B6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_26942019-62d2-4a18-b9c1-7e16640d4ee7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Central Arkansas Christian Schools",
      "poi_type": "Education",
      "poi_address": "6101 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-970c-74df-9ef9-8267efc5ba81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-970c-74df-9ef9-8267efc5ba81",
        "storage_key": "property/6737460151192626/019e1df9-970c-74df-9ef9-8267efc5ba81.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://cacmustangs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15464187513231867807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-arkansas-christian-schools",
      "poi_latitude": "34.812085",
      "poi_longitude": "-92.2446152",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-758-3160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNbW58ri90ocRn383SpzUm9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6c86efb9-8e0d-4fea-b621-7fa0760604bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Calvary Academy",
      "poi_type": "Education",
      "poi_address": "1401 Calvary Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.calvary.academy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12699959847531300548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "calvary-academy",
      "poi_latitude": "34.7790949",
      "poi_longitude": "-92.25105",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-753-0001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmbxHCUO80ocRxMbTrTFSP7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fb3dca81-aaab-45d1-9c00-9447184d3a6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "University of Arkansas – Pulaski Technical College",
      "poi_type": "Education",
      "poi_address": "3000 W Scenic Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-9246-7540-8140-76817b6d244c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-9246-7540-8140-76817b6d244c",
        "storage_key": "property/6737460151192626/019e1df7-9246-7540-8140-76817b6d244c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.uaptc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3922972585545535160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas--pulaski-technical-college",
      "poi_latitude": "34.78212980000001",
      "poi_longitude": "-92.2993636",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-812-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ_E4js280ocRuI4JIcgycTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9d3dfe12-6f2b-44df-aa89-7f841a4f461b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Regal McCain Mall",
      "poi_type": "Entertainment",
      "poi_address": "3929 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-98a2-729a-80fe-6cd11b09d355.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-98a2-729a-80fe-6cd11b09d355",
        "storage_key": "property/6737460151192626/019e1df9-98a2-729a-80fe-6cd11b09d355.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-mccain-mall-0541?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8580205952362246530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-mccain-mall",
      "poi_latitude": "34.79336",
      "poi_longitude": "-92.227005",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-ce40-75ba-8b4f-75a36532e8ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df9-ce40-75ba-8b4f-75a36532e8ec",
        "storage_key": "property/6737460151192626/019e1df9-ce40-75ba-8b4f-75a36532e8ec.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJxyek4Cu80ocRgnE-ktoDE3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f90e281a-2fda-4fc0-bcc3-67a314855083",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Arkansas Inland Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "120 Riverfront Park Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_long_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-97e7-743a-ada8-14d630776e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-97e7-743a-ada8-14d630776e5f",
        "storage_key": "property/6737460151192626/019e1df9-97e7-743a-ada8-14d630776e5f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/arkansas-inland-maritime-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9401581648013172689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-inland-maritime-museum",
      "poi_latitude": "34.7522251",
      "poi_longitude": "-92.2669543",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-371-8320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7fa-7134-a243-b7bb91b1e0f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7fa-7134-a243-b7bb91b1e0f1",
        "storage_key": "property/6737460151192626/019e1df7-c7fa-7134-a243-b7bb91b1e0f1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJHa_JEH670ocR0R-oeLIgeYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bcf7a705-e56b-4a1f-a2aa-f025129f6589",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Simmons Bank Arena",
      "poi_type": "Entertainment",
      "poi_address": "1 Simmons Bank Arena Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "Sports & entertainment venue with 18,000 seats hosting basketball, trade shows & major musical acts.",
      "poi_long_description": "Sports & entertainment venue with 18,000 seats hosting basketball, trade shows & major musical acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-9622-77aa-92d5-493ce823e6e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-9622-77aa-92d5-493ce823e6e2",
        "storage_key": "property/6737460151192626/019e1df7-9622-77aa-92d5-493ce823e6e2.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://simmonsbankarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13831376352313287939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simmons-bank-arena",
      "poi_latitude": "34.7550895",
      "poi_longitude": "-92.2643235",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-340-5660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeTmHEoC80ocRAyVfuoLr8r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_534e2273-66f2-41fd-a7ad-ae2bac05bf7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "The Joint Comedy Theater",
      "poi_type": "Entertainment",
      "poi_address": "301 Main St #102, North Little Rock, AR 72114, USA",
      "poi_short_description": "Cozy theater/cafe offering stand-up comedy & other shows, plus specialty coffee drinks, beer, wine.",
      "poi_long_description": "Cozy theater/cafe offering stand-up comedy & other shows, plus specialty coffee drinks, beer, wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-9c26-711c-9019-24433ca7c3df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-9c26-711c-9019-24433ca7c3df",
        "storage_key": "property/6737460151192626/019e1df9-9c26-711c-9019-24433ca7c3df.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.thejointargenta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3938605659390243919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-joint-comedy-theater",
      "poi_latitude": "34.7564632",
      "poi_longitude": "-92.2678964",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-372-0210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1o_1oO80ocRT3RMxvq8qDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "comedy_club"
    },
    {
      "id": "custom_175dd29a-769f-48dd-b2e7-1098234f48a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Argenta Contemporary Theatre",
      "poi_type": "Entertainment",
      "poi_address": "405 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Nonprofit organization presenting a variety of performing arts productions for all ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-9ab4-766a-917d-6ef21a60d956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-9ab4-766a-917d-6ef21a60d956",
        "storage_key": "property/6737460151192626/019e1df9-9ab4-766a-917d-6ef21a60d956.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://argentacontemporarytheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5638920590178178111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "argenta-contemporary-theatre",
      "poi_latitude": "34.7573812",
      "poi_longitude": "-92.2679905",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-353-1443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWbK4YO80ocRP9Q0hmZ4QU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_384805ca-7538-4d91-ace1-d82128f29e2b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Museum of Discovery",
      "poi_type": "Entertainment",
      "poi_address": "500 President Clinton Ave Ste. 150, Little Rock, AR 72201, USA",
      "poi_short_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_long_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-9498-70a9-9a34-70b6612884d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-9498-70a9-9a34-70b6612884d3",
        "storage_key": "property/6737460151192626/019e1df7-9498-70a9-9a34-70b6612884d3.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.museumofdiscovery.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16338434694446452897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-discovery",
      "poi_latitude": "34.7476729",
      "poi_longitude": "-92.2646549",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-396-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7fa-7134-a243-b7bb91b1e0f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7fa-7134-a243-b7bb91b1e0f1",
        "storage_key": "property/6737460151192626/019e1df7-c7fa-7134-a243-b7bb91b1e0f1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUmT0ni70ocRoRBmNMrHveI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cc274ec4-8f1a-4579-8936-4eb92452537a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Arkansas Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "501 E 9th St, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-98a3-719c-91ca-ace7228e74a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-98a3-719c-91ca-ace7228e74a4",
        "storage_key": "property/6737460151192626/019e1df7-98a3-719c-91ca-ace7228e74a4.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "https://arkmfa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16794530987996013232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-museum-of-fine-arts",
      "poi_latitude": "34.7380757",
      "poi_longitude": "-92.2660985",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-372-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7fa-7134-a243-b7bb91b1e0f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7fa-7134-a243-b7bb91b1e0f1",
        "storage_key": "property/6737460151192626/019e1df7-c7fa-7134-a243-b7bb91b1e0f1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9p-Prq70ocRsOLKzPMoEuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_894908f1-0234-4b97-970b-9167b6b6dd35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Robinson Center",
      "poi_type": "Entertainment",
      "poi_address": "426 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "Renovated 1939 theater features an expansive performance space for musicals, plays & more.",
      "poi_long_description": "Renovated 1939 theater features an expansive performance space for musicals, plays & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-9cfd-746d-ac0d-0ca09db2d771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-9cfd-746d-ac0d-0ca09db2d771",
        "storage_key": "property/6737460151192626/019e1df9-9cfd-746d-ac0d-0ca09db2d771.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.robinsoncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15299738811072087964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robinson-center",
      "poi_latitude": "34.7492294",
      "poi_longitude": "-92.2744598",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-244-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0xGEWO70ocRnIc1HmOXU9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_e045e21e-ab33-4d6b-a37f-b207d31aaeba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-North Little Rock",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 Springhill Dr, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-a509-73e5-8acf-c45fd23a3f79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-a509-73e5-8acf-c45fd23a3f79",
        "storage_key": "property/6737460151192626/019e1df7-a509-73e5-8acf-c45fd23a3f79.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.baptist-health.com/find-care/location/baptist-health-medical-center-north-little-rock/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12673750733774113147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-north-little-rock",
      "poi_latitude": "34.7835092",
      "poi_longitude": "-92.2224382",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-202-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e7-70e7-b315-67119a017f9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e7-70e7-b315-67119a017f9c",
        "storage_key": "property/6737460151192626/019e1df7-c7e7-70e7-b315-67119a017f9c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23mhdJ2-0ocRe8lz2iQ14q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_08262887-109e-4b4d-add1-9673fd3e0da6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Arkansas Surgical Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "5201 Northshore Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-a1ab-740f-bf15-22cd8e39f3e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-a1ab-740f-bf15-22cd8e39f3e4",
        "storage_key": "property/6737460151192626/019e1df9-a1ab-740f-bf15-22cd8e39f3e4.webp",
        "width": 1280,
        "height": 790
      },
      "poi_business_url": "http://www.arksurgicalhospital.com/?utm_source=GMB&utm_medium=organic&utm_campaign=office",
      "poi_directions_map_url": "https://maps.google.com/?cid=6493682624892903548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-surgical-hospital",
      "poi_latitude": "34.8001818",
      "poi_longitude": "-92.348361",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-748-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE3d0xVOi0ocRfCDePPExHlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_01950938-2528-4c96-9135-cc5746440a2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "PrimeCARE Medical Clinic - Sherwood",
      "poi_type": "Health and Wellness",
      "poi_address": "10301 Johnson Dr, Sherwood, AR 72120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-a65e-71bd-922f-a1a52b85716a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-a65e-71bd-922f-a1a52b85716a",
        "storage_key": "property/6737460151192626/019e1df9-a65e-71bd-922f-a1a52b85716a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pcmc-ar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11289519483661740986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primecare-medical-clinic---sherwood",
      "poi_latitude": "34.8514939",
      "poi_longitude": "-92.2243972",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-812-6655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBxlCFzO80ocRumuC7CdurJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_7b4528b5-6982-42fc-ada3-abca44f3e387",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2501 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-88be-756c-a17c-9bda558f7902.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-88be-756c-a17c-9bda558f7902",
        "storage_key": "property/6737460151192626/019e1df9-88be-756c-a17c-9bda558f7902.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/north-little-rock-ar-pharmacies/2501-mccain-blvd-north-little-rock-ar-72116/storeid=10975?WT.mc_id=LS_GOOGLE_RX_10975",
      "poi_directions_map_url": "https://maps.google.com/?cid=3917708257385930939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "34.7975923",
      "poi_longitude": "-92.2378466",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-404-6059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-ce42-7641-b0b8-ad1c442fe179.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df9-ce42-7641-b0b8-ad1c442fe179",
        "storage_key": "property/6737460151192626/019e1df9-ce42-7641-b0b8-ad1c442fe179.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSdrsu1690ocRu2AaN-d-XjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e74c8b93-57f8-4382-a7ae-899e7b105e3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Health and Wellness",
      "poi_address": "4450 E McCain Blvd, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-9337-70b2-8e8e-d137418b688a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-9337-70b2-8e8e-d137418b688a",
        "storage_key": "property/6737460151192626/019e1df9-9337-70b2-8e8e-d137418b688a.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1105-north-little-rock-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10064490569118038448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "34.7865186",
      "poi_longitude": "-92.2146068",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-945-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c841-7379-bf44-02dc6c163f86",
        "storage_key": "property/6737460151192626/019e1df7-c841-7379-bf44-02dc6c163f86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcxRChYS-0ocRsLmMQdlArIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0903d0b1-44f0-42b2-88ee-c356b5f4306a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Dogtown Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1112 W 9th St Suite B, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-a392-7408-b10d-5d4612d41c6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-a392-7408-b10d-5d4612d41c6c",
        "storage_key": "property/6737460151192626/019e1df9-a392-7408-b10d-5d4612d41c6c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://dogtown-fitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18264505177320648581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dogtown-fitness",
      "poi_latitude": "34.7624642",
      "poi_longitude": "-92.2803017",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-230-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_-mQCS90ocRhe96dLCOeP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b1e2cff4-8552-4bfb-9c65-ac20c74591df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Rock City Complete Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9000 Commerce Cove, North Little Rock, AR 72113, USA",
      "poi_short_description": "CrossFit, bootcamp and personal training classes are offered at this fitness studio with a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-a198-72b9-967f-e27c4e4a30f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-a198-72b9-967f-e27c4e4a30f8",
        "storage_key": "property/6737460151192626/019e1df9-a198-72b9-967f-e27c4e4a30f8.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://rockcitycompletefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4646841560244393608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-city-complete-fitness",
      "poi_latitude": "34.8409384",
      "poi_longitude": "-92.3783618",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-200-4483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ94I52hWi0ocRiJbjbcflfEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4c194a61-eb74-4cae-8114-fb7e400fa0d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4617 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Chain gym with tanning beds and hydromassage in North Park Mall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-9a0a-77c2-87e2-99957d4e9dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-9a0a-77c2-87e2-99957d4e9dc0",
        "storage_key": "property/6737460151192626/019e1df7-9a0a-77c2-87e2-99957d4e9dc0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/north-little-rock-ar?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7560349064309511589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.7976804",
      "poi_longitude": "-92.2567809",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-377-9535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSttMYK90ocRpRUg5GrB62g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_868c7a70-8d58-4432-a58a-10830feb34e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Blue Yoga Nyla",
      "poi_type": "Health and Wellness",
      "poi_address": "3721 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.blueyoganyla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8960569883019740698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-yoga-nyla",
      "poi_latitude": "34.789767",
      "poi_longitude": "-92.260687",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh8JtWQC90ocRGoZ0XtVWWnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_ddc78a33-c1ab-49c2-987a-c88e1ace70e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Idlewild Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3411 Idlewild Ave, North Little Rock, AR 72116, USA",
      "poi_short_description": "Peaceful park featuring a tennis court, basketball court, and a children's playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-a724-73a4-aa15-6a4686e4c4a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-a724-73a4-aa15-6a4686e4c4a3",
        "storage_key": "property/6737460151192626/019e1df9-a724-73a4-aa15-6a4686e4c4a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/idlewild-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1762240858135831597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "idlewild-park",
      "poi_latitude": "34.7867052",
      "poi_longitude": "-92.2566643",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-791-8537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c845-70ee-847e-38ae9b4dd942",
        "storage_key": "property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqVAymVC80ocRLaTdRbm8dBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fc7ab8be-3309-4d5a-ab7c-b751b25ef63b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Fearneyhough Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "325 E C Ave, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-a602-755f-b0b2-5a11a3efd5a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-a602-755f-b0b2-5a11a3efd5a0",
        "storage_key": "property/6737460151192626/019e1df9-a602-755f-b0b2-5a11a3efd5a0.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1450101919311362799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fearneyhough-park",
      "poi_latitude": "34.7850477",
      "poi_longitude": "-92.2556249",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-791-8537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c845-70ee-847e-38ae9b4dd942",
        "storage_key": "property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzO59Fq80ocR73qqPAPMHxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a97a454b-5d75-4d96-bb66-bd5cba36f5e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Crestview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "141 Crestview Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Fenced, maintained space featuring a playground with slides and picnic tables, plus trails for walking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-aa50-77c6-af1e-0b11284c5b6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-aa50-77c6-af1e-0b11284c5b6c",
        "storage_key": "property/6737460151192626/019e1df9-aa50-77c6-af1e-0b11284c5b6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/city-park-information/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6688841659880611369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crestview-park",
      "poi_latitude": "34.7823188",
      "poi_longitude": "-92.264406",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-791-8537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c845-70ee-847e-38ae9b4dd942",
        "storage_key": "property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTmvQfa80ocRKZ4E-AyK01w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a785d36d-803d-4151-8a59-d17a9dc149aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "McGee Park - Lakewood Property Owners Association",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 Crestwood Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-a9e6-758e-aa48-3818924f38d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-a9e6-758e-aa48-3818924f38d2",
        "storage_key": "property/6737460151192626/019e1df9-a9e6-758e-aa48-3818924f38d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3548725240220416467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcgee-park---lakewood-property-owners-association",
      "poi_latitude": "34.79915740000001",
      "poi_longitude": "-92.2351565",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ80DRs290ocR0_nM1M2aPzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_b2b66bf1-5d24-404d-8cf6-9b8f01a0eca3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "The Old Mill",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3800 Lakeshore Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Quaint 1880's-style water mill with rustic outdoor sculptures, located in T.R. Pugh Memorial Park.",
      "poi_long_description": "Quaint 1880's-style water mill with rustic outdoor sculptures, located in T.R. Pugh Memorial Park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-98dd-753d-86a2-8e517272a283.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-98dd-753d-86a2-8e517272a283",
        "storage_key": "property/6737460151192626/019e1df7-98dd-753d-86a2-8e517272a283.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/old-mill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13753738084307160303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-old-mill",
      "poi_latitude": "34.7913123",
      "poi_longitude": "-92.249526",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Xsnok680ocR78zj0OoX374",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_b4683361-1d6d-46b2-bcc2-008030ee36c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Burns Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "North Little Rock, AR 72118, USA",
      "poi_short_description": "Park offering ball fields, a 36-hole golf course, multi-use trails & fishing in the Arkansas River.",
      "poi_long_description": "Park offering ball fields, a 36-hole golf course, multi-use trails & fishing in the Arkansas River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-b83f-71eb-b91b-b1a4231414ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-b83f-71eb-b91b-b1a4231414ab",
        "storage_key": "property/6737460151192626/019e1df9-b83f-71eb-b91b-b1a4231414ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/burns-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18303069099405761385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns-park",
      "poi_latitude": "34.7976957",
      "poi_longitude": "-92.3099177",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c845-70ee-847e-38ae9b4dd942",
        "storage_key": "property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzXtiMt-i0ocRaVuCQV-QAf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f4fdf87d-d609-4a2a-95a0-4179893032ed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Campbell Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4100 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Park with paved riverside trails for walking, running, and biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-b549-70d8-b7a3-e4fca2b71cfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-b549-70d8-b7a3-e4fca2b71cfe",
        "storage_key": "property/6737460151192626/019e1df9-b549-70d8-b7a3-e4fca2b71cfe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/campbell-lake-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6847212567647828084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-lake-park",
      "poi_latitude": "34.7956794",
      "poi_longitude": "-92.3516307",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c845-70ee-847e-38ae9b4dd942",
        "storage_key": "property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa8kpt7Kj0ocRdDg9XI0vBl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1efc54f2-e97e-4044-8f8c-6cc81e9d7a3e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Riverview Skateboard Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2801 River Rd, North Little Rock, AR 72114, USA",
      "poi_short_description": "Recreational venue with a skate park, a playground, and a bike/walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-b445-76ef-96d1-9c6ff7421517.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-b445-76ef-96d1-9c6ff7421517",
        "storage_key": "property/6737460151192626/019e1df9-b445-76ef-96d1-9c6ff7421517.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/riverview-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11151943499546355846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-skateboard-park",
      "poi_latitude": "34.76926340000001",
      "poi_longitude": "-92.2967257",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVliDSy90ocRhuiv_Yapw5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "skateboard_park"
    },
    {
      "id": "custom_ecc5a696-c215-4126-9f1f-63417602c061",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "North Shore Riverwalk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "North Little Rock, AR 72114, USA",
      "poi_short_description": "City park featuring a riverwalk, trails, and a bridge, plus space for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-b602-753e-b77d-b4ef896470fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-b602-753e-b77d-b4ef896470fe",
        "storage_key": "property/6737460151192626/019e1df9-b602-753e-b77d-b4ef896470fe.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.nps.gov/places/north-shore-riverwalk-park.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4170622964056154528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-shore-riverwalk-park",
      "poi_latitude": "34.7533362",
      "poi_longitude": "-92.2714573",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-758-1424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c845-70ee-847e-38ae9b4dd942",
        "storage_key": "property/6737460151192626/019e1df7-c845-70ee-847e-38ae9b4dd942.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw283eYK80ocRoGGnKH0H4Tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_42723938-9fd8-4dc2-b489-b16333255b1d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Rock Region METRO",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-bb23-73e8-a137-6f719e94523c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-bb23-73e8-a137-6f719e94523c",
        "storage_key": "property/6737460151192626/019e1df9-bb23-73e8-a137-6f719e94523c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174036123689371751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-region-metro",
      "poi_latitude": "34.7624459",
      "poi_longitude": "-92.2689822",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-375-6717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtavgzIW80ocRZ0i37YsCcHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_29fd9981-c927-4c2d-810a-f85eeb215931",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "River Cities Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Capitol Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-bb15-729c-b9e0-0483c1f8f313.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-bb15-729c-b9e0-0483c1f8f313",
        "storage_key": "property/6737460151192626/019e1df9-bb15-729c-b9e0-0483c1f8f313.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3809342745980765106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-cities-travel-center",
      "poi_latitude": "34.7442945",
      "poi_longitude": "-92.2680391",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuazOJHq70ocRsgPlcQuB3TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_b7c7a33f-8f73-433a-9c97-83013b14c2b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Bill and Hillary Clinton National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_long_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-b131-70fe-8a66-4520b5522427.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-b131-70fe-8a66-4520b5522427",
        "storage_key": "property/6737460151192626/019e1df7-b131-70fe-8a66-4520b5522427.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clintonairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7788752853462898252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-and-hillary-clinton-national-airport",
      "poi_latitude": "34.7315031",
      "poi_longitude": "-92.2233332",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-372-3439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-cab4-7169-835c-359e8190493a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-cab4-7169-835c-359e8190493a",
        "storage_key": "property/6737460151192626/019e1df7-cab4-7169-835c-359e8190493a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eIlS2C50ocRTFb3IXQ1F2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_845c78c2-3613-4263-806a-4b475c3a7bda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "North Little Rock Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8200 Remount Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-b467-7639-8d11-a4f7e3121359.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-b467-7639-8d11-a4f7e3121359",
        "storage_key": "property/6737460151192626/019e1df7-b467-7639-8d11-a4f7e3121359.webp",
        "width": 1280,
        "height": 582
      },
      "poi_business_url": "http://nlr.ar.gov/government/a_z_department_list/airport/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14818561348559290970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-municipal-airport",
      "poi_latitude": "34.831655",
      "poi_longitude": "-92.2591882",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-835-5654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-cab4-7169-835c-359e8190493a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-cab4-7169-835c-359e8190493a",
        "storage_key": "property/6737460151192626/019e1df7-cab4-7169-835c-359e8190493a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9wudIW90ocRWsI1zwgbps0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d9e716dd-8e12-4b03-a945-d8206b160ca6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-b77f-7255-b561-fc5325d43622.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-b77f-7255-b561-fc5325d43622",
        "storage_key": "property/6737460151192626/019e1df7-b77f-7255-b561-fc5325d43622.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=LRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=16485565726769375602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "34.750483",
      "poi_longitude": "-92.28700990000002",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-cac9-71a8-95ce-df173d0292d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-cac9-71a8-95ce-df173d0292d0",
        "storage_key": "property/6737460151192626/019e1df7-cac9-71a8-95ce-df173d0292d0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55EYqF-70ocRcmlxKa9-yOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_0ab3184a-ceb7-48a2-8793-7ac8f48a51be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Trolley Barn and Parking Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "600-662 N Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c16f-721e-8a6f-dc88d2a8e42f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c16f-721e-8a6f-dc88d2a8e42f",
        "storage_key": "property/6737460151192626/019e1df9-c16f-721e-8a6f-dc88d2a8e42f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rrmetro.org/services/streetcar/maps-schedules/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5695809784748258176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trolley-barn-and-parking-lot",
      "poi_latitude": "34.7595738",
      "poi_longitude": "-92.266672",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-375-6717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_3YuYa80ocRgDMdUNKUC08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_c61cce59-cdfb-4aee-8ee0-4e1c08ca3088",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "River Market & Pres Clinton Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c146-70da-9db5-8d5f0186c5cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c146-70da-9db5-8d5f0186c5cc",
        "storage_key": "property/6737460151192626/019e1df9-c146-70da-9db5-8d5f0186c5cc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8584000391786929158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-market--pres-clinton-ave",
      "poi_latitude": "34.747178",
      "poi_longitude": "-92.265628",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCy-bKXm70ocRBhxGWOB-IHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2bcbd836-f24a-47dc-8bfa-a0da2c5a9b00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Big Dam Bridge",
      "poi_type": "Transportation & Transit",
      "poi_address": "4000 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_long_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-9e40-7606-9acf-3fd9f1d32070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-9e40-7606-9acf-3fd9f1d32070",
        "storage_key": "property/6737460151192626/019e1df9-9e40-7606-9acf-3fd9f1d32070.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17869723390477343867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-dam-bridge",
      "poi_latitude": "34.7925668",
      "poi_longitude": "-92.3584127",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7GbOUyi0ocRexzk674C_vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bridge"
    },
    {
      "id": "custom_8d8c86d0-b075-464d-9b85-21f332788313",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Eugene J. Towbin VA Healthcare Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 Fort Roots Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c2ea-73d4-91a8-4299e5ebe4be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c2ea-73d4-91a8-4299e5ebe4be",
        "storage_key": "property/6737460151192626/019e1df9-c2ea-73d4-91a8-4299e5ebe4be.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.littlerock.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1150338823434071329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eugene-j-towbin-va-healthcare-center",
      "poi_latitude": "34.7777208",
      "poi_longitude": "-92.2976361",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-257-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-cad6-755c-9fb9-bd4b81e78a2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-cad6-755c-9fb9-bd4b81e78a2e",
        "storage_key": "property/6737460151192626/019e1df7-cad6-755c-9fb9-bd4b81e78a2e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQccfRMm80ocRIe0grhDT9g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b7675760-f8c5-4d34-a235-cecbd4610787",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "UAMS Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c167-756e-9541-6ed25e6868ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c167-756e-9541-6ed25e6868ca",
        "storage_key": "property/6737460151192626/019e1df9-c167-756e-9541-6ed25e6868ca.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://uamshealth.com/location/uams-medical-center/?utm_source=google&utm_medium=gmb&utm_campaign=clinical&utm_term=location&utm_content=profile&utm_specs=uams-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=980427499144927317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uams-medical-center",
      "poi_latitude": "34.7493145",
      "poi_longitude": "-92.3205392",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-686-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e7-70e7-b315-67119a017f9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e7-70e7-b315-67119a017f9c",
        "storage_key": "property/6737460151192626/019e1df7-c7e7-70e7-b315-67119a017f9c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJz5GH8ql0ocRVdiOrp0tmw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_27691173-1b47-464e-b2ac-918456f778ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Arkansas Children's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Children's Way, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-a192-7499-a2d5-38a48191c1a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-a192-7499-a2d5-38a48191c1a2",
        "storage_key": "property/6737460151192626/019e1df7-a192-7499-a2d5-38a48191c1a2.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800723640570466137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-hospital",
      "poi_latitude": "34.7430995",
      "poi_longitude": "-92.2918544",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 501-441-3453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e7-70e7-b315-67119a017f9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e7-70e7-b315-67119a017f9c",
        "storage_key": "property/6737460151192626/019e1df7-c7e7-70e7-b315-67119a017f9c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5Fcp1q70ocRWc9Rbm9yR9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_636dca17-de53-4e30-919d-732553057ec1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "University of Arkansas at Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c46e-75cb-9a95-71b055739405.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c46e-75cb-9a95-71b055739405",
        "storage_key": "property/6737460151192626/019e1df9-c46e-75cb-9a95-71b055739405.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ualr.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912235513023897276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas-at-little-rock",
      "poi_latitude": "34.7252717",
      "poi_longitude": "-92.3378705",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 501-916-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e6-7554-aaaf-c243b1b4dad4",
        "storage_key": "property/6737460151192626/019e1df7-c7e6-7554-aaaf-c243b1b4dad4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_aUdFik0ocRvB5dKX0wEsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dee6b9d8-ef60-4280-ba3f-237f43662d28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Dillard's Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Cantrell Rd, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-ad2d-74fd-998c-eb005a9dc2e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-ad2d-74fd-998c-eb005a9dc2e7",
        "storage_key": "property/6737460151192626/019e1df7-ad2d-74fd-998c-eb005a9dc2e7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11049574453805387583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dillards-corporate-office",
      "poi_latitude": "34.75433659999999",
      "poi_longitude": "-92.2878465",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 501-376-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96xpTae80ocRPw9NLmz5V5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e3e2bd9b-0286-445b-908e-748af9359779",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Windstream (Kinetic, Wholesale, Enterprise)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4005 N Rodney Parham Rd, Little Rock, AR 72212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c4d0-76d3-b38b-6d2d8e946b58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c4d0-76d3-b38b-6d2d8e946b58",
        "storage_key": "property/6737460151192626/019e1df9-c4d0-76d3-b38b-6d2d8e946b58.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.windstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16791035967187703863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windstream-kinetic-wholesale-enterprise",
      "poi_latitude": "34.7871432",
      "poi_longitude": "-92.3974489",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 877-759-9020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVK6onOh0ocRN9gH2z--Bek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "telecommunications_service_provider"
    },
    {
      "id": "custom_be6b5d5e-9c04-4c01-87b1-3ae8b48ac324",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Heifer International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 World Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c782-7420-9a8d-921860412a80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c782-7420-9a8d-921860412a80",
        "storage_key": "property/6737460151192626/019e1df9-c782-7420-9a8d-921860412a80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.heifer.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15947581606820737385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heifer-international",
      "poi_latitude": "34.7447963",
      "poi_longitude": "-92.2561293",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-948-6437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7e5-73d8-b571-23201f1bb09b",
        "storage_key": "property/6737460151192626/019e1df7-c7e5-73d8-b571-23201f1bb09b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6hY55Wj0ocRaXEaPfowUd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_30b21772-eeb7-452b-b632-030e8325b0d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "William J. Clinton Library and Museum",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_long_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-9328-71de-9fa1-2be6282223ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-9328-71de-9fa1-2be6282223ed",
        "storage_key": "property/6737460151192626/019e1df7-9328-71de-9fa1-2be6282223ed.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.clintonpresidentialcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8035004359637958132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-j-clinton-library-and-museum",
      "poi_latitude": "34.7464097",
      "poi_longitude": "-92.2583824",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-370-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-c7fa-7134-a243-b7bb91b1e0f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-c7fa-7134-a243-b7bb91b1e0f1",
        "storage_key": "property/6737460151192626/019e1df7-c7fa-7134-a243-b7bb91b1e0f1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWsmz4O70ocR9H3v0OQRgm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_caf54c83-014b-4b95-9b90-3e7a9bb3fdfc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Simmons Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "425 W Capitol Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c598-72a6-ae56-9d10da1fa3c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c598-72a6-ae56-9d10da1fa3c1",
        "storage_key": "property/6737460151192626/019e1df9-c598-72a6-ae56-9d10da1fa3c1.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://www.simmonsbank.com/locations/little-rock-downtown-tower?utm_source=gmb&utm_medium=yext&utm_campaign=locallistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4863110573748472749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simmons-bank",
      "poi_latitude": "34.7442184",
      "poi_longitude": "-92.2757271",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-377-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-ce41-75a9-a1a2-ce8f030733bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df9-ce41-75a9-a1a2-ce8f030733bb",
        "storage_key": "property/6737460151192626/019e1df9-ce41-75a9-a1a2-ce8f030733bb.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJKXv8qGW70ocRrUu5C009fUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_142034df-bb20-4a1e-a705-bcd96a04f866",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "custom",
      "poi_name": "Arkansas State Capitol",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Woodlane St, Little Rock, AR 72201, USA",
      "poi_short_description": "Grand state capitol building featuring free guided tours, temporary exhibits & a gift shop.",
      "poi_long_description": "Grand state capitol building featuring free guided tours, temporary exhibits & a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df9-c86c-77bb-be47-021a933f682c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df9-c86c-77bb-be47-021a933f682c",
        "storage_key": "property/6737460151192626/019e1df9-c86c-77bb-be47-021a933f682c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sos.arkansas.gov/state-capitol/state-capitol-tour-information",
      "poi_directions_map_url": "https://maps.google.com/?cid=8612870824380092411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-state-capitol",
      "poi_latitude": "34.7469598",
      "poi_longitude": "-92.28905",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-682-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-cad6-755c-9fb9-bd4b81e78a2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-cad6-755c-9fb9-bd4b81e78a2e",
        "storage_key": "property/6737460151192626/019e1df7-cad6-755c-9fb9-bd4b81e78a2e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlak53Fu70ocR-0-Av2EQh3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_9e7c76a4-3cbe-492e-ac13-d5e4b1a25890",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f4ec9135-806b-4673-a9ba-e39f73e8bb36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bf753be2-b293-494b-8361-718283ad428d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2e10729b-ce61-4cb6-a4c0-664845f1f4eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1ff63268-150b-4839-aa35-5bd10f2a2029",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_162aeaf9-7738-4988-a8f3-35393b35375e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_04e17057-6b3f-4a05-8ac1-40772be9b242",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "rating": "5",
      "name": "Andrew Conn",
      "text": "The maintenance workers are great. Everyone in front office are kind and they will help with whatever u need help with. S.K has been a real help. Thank you Indian hills",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_23dd85ec-6602-40f6-84f3-c18dd270d6a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "rating": "5",
      "name": "Mariah Bright",
      "text": "The management team at Indian Hills Apartments is fantastic. They were so helpful and supportive to me when I worked with them. They were informative and supportive while I made the decision about my apartment. Evette and Esme were great to work with and I highly recommend this team if you are looking to relocate. This is a great apartment complex.",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_7cb679dd-e232-4c80-a063-b05d0324ffe4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "rating": "5",
      "name": "Tryone Pope",
      "text": "I have been working with SK since I started my lease here in December of 25 and she is so willing to help and go above and beyond for her residents here. I love my apartment and my community here at Indian Hills!",
      "date": "2026-05-08",
      "title": "false"
    },
    {
      "id": "custom_e006a647-45f3-4dd6-b893-928886ff1682",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "rating": "5",
      "name": "KeKe Smith",
      "text": "I got referred to this place and I was not disappointed… they answer the phone each and every time. They got me in the same day for a walk through and baby I LOVED the energy. Yvette and SK was such a vibe! And the place is very nice! The process was easy and they will walk u through any questions with such grace and patience! I love them down! And I just met them! So I kno the living experience will be even better!",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_1b4242c2-4e7c-4bcd-9258-3f65f785ec09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "rating": "5",
      "name": "Dalonda Baker",
      "text": "I just want to take the time out of my day to give recognition to Mrs.Eyvtte. She was very professional and welcoming. She made me feel so comfortable on renting and I was sold immediately, she deserves a raise or something lol and i am so excited to be a part of the nice and quiet community. I couldn’t ask for anything else all thanks to Mrs.Eyvtte.",
      "date": "2026-05-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_883550264522ded65b45bc8c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019e1df7-6c25-72c3-846f-311bb24369f2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df7-6c25-72c3-846f-311bb24369f2",
        "storage_key": "property/6737460151192626/019e1df7-6c25-72c3-846f-311bb24369f2.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6684d4392aaa007ba8d63243"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e5d-e7c3-778a-a272-9b358f147e72",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-indian-hills-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626"
    },
    {
      "lead_collector_id": "019a1859-694a-749f-8b14-ccc1895cfbbe",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-indian-hills-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-north-little-rock",
      "search_query": "pet friendly apartments North Little Rock",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in North Little Rock",
      "h2_subtitle": "Explore our pet-friendly apartments in North Little Rock. Discover spacious living spaces with amenities like a pet park and more.",
      "page_copy": "Welcome to Indian Hills, where pet-friendly living meets comfort and convenience in North Little Rock, AR. Our community offers spacious one, two, and three-bedroom apartments designed with your furry friends in mind. With our dedicated pet park, your pets will enjoy their new home just as much as you do! Our community embraces all the comforts of modern living, making it the perfect choice for pet owners looking for a vibrant neighborhood. \n\nLocated in Pulaski County, Indian Hills offers an ideal setting for you and your pets. Beyond pet amenities, enjoy a fitness center, playground, and on-site management, ensuring all your needs are met. Gain peace of mind with 24-hour maintenance on request. Experience a new, hassle-free lifestyle tailored to all residents, both two-legged and four! Schedule a visit today and embrace the pet-friendly environment at Indian Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "019d0784-02b2-708c-a450-3ac12408fa0e",
        "storage_key": "property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
        "width": 1239,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in North Little Rock",
      "seo_description": "Find pet-friendly apartments in North Little Rock! Enjoy a great community with a pet park and more. Schedule a tour of Indian Hills today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "page_item_url": "apartments-with-pool-north-little-rock",
      "search_query": "apartments with a pool North Little Rock",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in North Little Rock",
      "h2_subtitle": "Discover our apartments with a pool in North Little Rock. Enjoy relaxing days by the poolside at Indian Hills.",
      "page_copy": "Dive into the refreshing lifestyle offered at Indian Hills, one of North Little Rock's finest communities, featuring apartments with a pool. Our one, two, and three-bedroom apartments provide the perfect combination of relaxation and convenience, tailored for your comfort. Unwind in style with access to a sparkling pool, perfect for those warm Arkansas days. \n\nPositioned in the heart of Pulaski County, Indian Hills ensures residents enjoy more than just poolside leisure. With amenities like a fitness center, playground, and pet-friendly spaces, there's something for everyone. Plus, our dedicated on-site management team and round-the-clock maintenance ensure you experience hassle-free living. Discover the perfect place to call home by booking your tour of Indian Hills today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "019d0784-02b2-708c-a450-3ac12408fa0e",
        "storage_key": "property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
        "width": 1239,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in North Little Rock",
      "seo_description": "Explore our North Little Rock apartments with a pool. Enjoy relax and convenience at Indian Hills with top amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-pulaski-county",
      "search_query": "in unit laundry apartments Pulaski County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Pulaski County",
      "h2_subtitle": "Experience the convenience of in-unit laundry in our Pulaski County apartments. Enjoy modern living at Indian Hills.",
      "page_copy": "At Indian Hills in Pulaski County, discover the perfect blend of convenience and comfort with in-unit laundry apartments. Choose from our spacious one, two, or three-bedroom layouts designed to simplify your daily routine. Enjoy a home where the hustle and bustle fade away, allowing you to focus on what matters most.\n\nOur community, located in North Little Rock, AR, offers more than just in-unit conveniences. Delight in our array of amenities, including a fitness center, playground, and pet-friendly areas, all within a beautifully maintained setting. Indian Hills provides easy access to essential services, with 24-hour maintenance and an on-site property manager. Explore our vibrant community today, where an enriched, hassle-free lifestyle awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "019d0784-02b2-708c-a450-3ac12408fa0e",
        "storage_key": "property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
        "width": 1239,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Pulaski County",
      "seo_description": "Find in-unit laundry apartments in Pulaski County at Indian Hills. Enjoy modern conveniences and top amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-72116",
      "search_query": "air conditioned apartments 72116",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in 72116",
      "h2_subtitle": "Stay cool in our air conditioned apartments in the 72116 area. Enjoy comfortable living at Indian Hills.",
      "page_copy": "Welcome to Indian Hills, where you can enjoy cool, comfortable living in our air conditioned apartments in the 72116 area. Our spacious one, two, and three-bedroom homes are designed to provide a refreshing retreat from the Arkansas heat. With efficient air conditioning, you can relax and unwind in climate-controlled comfort all year round.\n\nLocated in North Little Rock, Indian Hills offers more than just cool interiors. Our community includes amenities like a playground, fitness center, and pet-friendly spaces, ensuring a fulfilling lifestyle. The on-site management team and 24-hour maintenance service are always ready to assist, enhancing your living experience. Discover the perfect balance of comfort and convenience by visiting Indian Hills today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "019d0784-02b2-708c-a450-3ac12408fa0e",
        "storage_key": "property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
        "width": 1239,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in 72116",
      "seo_description": "Enjoy air conditioned comfort in the 72116 zip code at Indian Hills. Discover spacious apartments and great amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "page_item_url": "dog-park-apartments-north-little-rock",
      "search_query": "dog park apartments North Little Rock",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in North Little Rock",
      "h2_subtitle": "Discover pet-friendly living with a dog park in North Little Rock. Find the perfect apartment at Indian Hills.",
      "page_copy": "Welcome to Indian Hills in North Little Rock, where your pets are just as important as your comfort! Our dog park apartments offer a pet-friendly environment complete with a dedicated dog park. Enjoy spacious one, two, and three-bedroom options that cater to the needs of you and your furry friends.\n\nSituated in Pulaski County, Indian Hills blends convenience with outdoor fun. Beyond the dog park, our community provides residents with access to a playground, fitness center, and various on-site amenities. With a caring on-site management team and 24-hour maintenance, Indian Hills ensures worry-free living for both you and your pet. Schedule a tour today and discover why Indian Hills is the perfect home for you and your pet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "019d0784-02b2-708c-a450-3ac12408fa0e",
        "storage_key": "property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
        "width": 1239,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in North Little Rock",
      "seo_description": "Live in North Little Rock with a dog park at Indian Hills. Pet-friendly apartments offering comfort and great amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "page_item_url": "one-bedroom-apartment-north-little-rock",
      "search_query": "one bedroom apartment North Little Rock",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartment in North Little Rock",
      "h2_subtitle": "Find your ideal one-bedroom apartment in North Little Rock at Indian Hills, complete with modern amenities.",
      "page_copy": "Discover the perfect one-bedroom apartment in North Little Rock at Indian Hills, where comfort meets convenience. Our thoughtfully designed spaces offer the ideal retreat with modern amenities and bright, spacious interiors. Whether you're seeking a cozy home or a dynamic living community, Indian Hills is crafted to meet your lifestyle needs.\n\nIndian Hills isn't just about great interiors. Set in the bustling heart of Pulaski County, enjoy access to a fitness center, playground, and even a pet-friendly dog park. With our dedicated on-site management and round-the-clock maintenance, your satisfaction is our priority. Contact us today to tour our one-bedroom offerings and find out why Indian Hills is the top choice for North Little Rock living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "019d0784-02b2-708c-a450-3ac12408fa0e",
        "storage_key": "property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
        "width": 1239,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartment in North Little Rock",
      "seo_description": "Explore one-bedroom apartments at Indian Hills in North Little Rock. Comfortable living with modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-north-little-rock-ar",
      "search_query": "2 bedroom apartments North Little Rock AR",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in North Little Rock, AR",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Indian Hills in North Little Rock, AR. Experience comfort like never before.",
      "page_copy": "Welcome to Indian Hills, offering the finest 2 bedroom apartments in North Little Rock, AR. Our community provides expansive living spaces that perfectly suit couples, small families, or roommates looking for a comfortable and stylish home. Each apartment is equipped with modern features, including double vanities, designed to enhance your living experience.\n\nLocated in the vibrant region of Pulaski County, Indian Hills presents more than just a premium living space. From the on-site fitness center and playground to the pet-friendly environment, conveniences are at your doorstep. Our committed on-site management team and 24-hour maintenance service ensure that your needs are met swiftly. Make Indian Hills your new home and relish the blend of convenience and relaxation in North Little Rock.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "019d0784-02b2-708c-a450-3ac12408fa0e",
        "storage_key": "property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
        "width": 1239,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in North Little Rock, AR",
      "seo_description": "Find spacious 2 bedroom apartments at Indian Hills in North Little Rock, AR. Enjoy modern amenities and a convenient location. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192626",
      "source": "generator",
      "page_item_url": "three-bedroom-rentals-in-pulaski-county",
      "search_query": "three bedroom rentals in Pulaski County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Rentals in Pulaski County",
      "h2_subtitle": "Discover spacious three bedroom rentals at Indian Hills within Pulaski County. Perfect for families seeking comfort and convenience.",
      "page_copy": "Indian Hills in Pulaski County offers three bedroom rentals with ample space for families or roommates desiring comfort and convenience. Situated in North Little Rock, our three-bedroom apartments provide modern amenities like double vanities and access to a pet park, harmonizing great design with functionality.\n\nEnjoy easy access to community features including a playground, fitness center, and professionally managed grounds. At Indian Hills, we aim to elevate your living experience with dedicated on-site management and 24-hour maintenance support. Step into a vibrant community environment and schedule a visit today to explore why Indian Hills is the top choice in Pulaski County for three bedroom rentals.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "019d0784-02b2-708c-a450-3ac12408fa0e",
        "storage_key": "property/6737460151192626/019d0784-02b2-708c-a450-3ac12408fa0e.webp",
        "width": 1239,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Rentals in Pulaski County",
      "seo_description": "Explore spacious three bedroom rentals in Pulaski County at Indian Hills. Enjoy modern amenities and community features. Book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3369"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483419"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4707260"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NWN62WMH"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "501-510-8831"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "501-530-9712"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "501-510-8956"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "501-530-8792"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "501-530-8927"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "501-298-4765"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "501-298-4749"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "501-530-9037"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "501-356-4949"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "501-300-7088"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "501-294-5300"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "501-510-8838"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "501-456-4303"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "501-365-8449"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "501-298-4062"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "501-521-1086"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321276568"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "501-530-9629"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "501-361-2716"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "670175711ee2832d"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "501-530-9025"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "501-510-8763"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "501-459-3915"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "501-530-8884"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "501-530-8932"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "501-298-4764"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.indianhillsapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192626/019e60f3-608e-7484-af28-8f9bb8824513.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "501-530-9698"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "501-300-7088"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3369",
  "custom_repli_id": "5028483419",
  "custom_realpage_id": "4707260",
  "custom_knock_a_link": "https://www.indianhillsapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.indianhillsapthome.com?utm_knock=g",
  "custom_knock_r_link": "https://www.indianhillsapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.indianhillsapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-NWN62WMH",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.indianhillsapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.indianhillsapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.indianhillsapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.indianhillsapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.indianhillsapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.indianhillsapthome.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "501-510-8831",
  "custom_knock_ads_link": "https://www.indianhillsapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.indianhillsapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "501-530-9712",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_ppn_link": "https://www.indianhillsapthome.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.indianhillsapthome.com?utm_knock=psa",
  "custom_knock_r_number": "501-510-8956",
  "custom_knock_w_number": "501-530-8792",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "501-530-8927",
  "custom_knock_amap_link": "https://www.indianhillsapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "501-298-4765",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "501-298-4749",
  "custom_knock_fb_number": "501-530-9037",
  "custom_knock_fl_number": "501-356-4949",
  "custom_knock_gp_number": "501-300-7088",
  "custom_knock_osoc_link": "https://www.indianhillsapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "501-294-5300",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.indianhillsapthome.com?utm_knock=bcard",
  "custom_knock_bnr_number": "501-510-8838",
  "custom_knock_cfres_link": "https://www.indianhillsapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppn_number": "501-456-4303",
  "custom_knock_psa_number": "501-365-8449",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "501-298-4062",
  "custom_knock_bandit_link": "https://www.indianhillsapthome.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.indianhillsapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "501-521-1086",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321276568",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "501-530-9629",
  "custom_knock_cfres_number": "501-361-2716",
  "custom_knock_chatgpt_link": "https://www.indianhillsapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "670175711ee2832d",
  "custom_knock_dirmail_link": "https://www.indianhillsapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_propbro_link": "https://www.indianhillsapthome.com?utm_knock=propbro",
  "custom_knock_bandit_number": "501-530-9025",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "501-510-8763",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.indianhillsapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "501-459-3915",
  "custom_knock_dirmail_number": "501-530-8884",
  "custom_knock_propbro_number": "501-530-8932",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "501-298-4764",
  "custom_knock_maintenance_link": "https://www.indianhillsapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192626/019e60f3-608e-7484-af28-8f9bb8824513.mp4",
  "custom_knock_maintenance_number": "501-530-9698",
  "custom_ppc_tracking_phone_number": "501-300-7088"
};

export const generatedAt = '2026-10-07T17:13:52.708Z';
